webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var BASE_URL = "/sigerh/sig";

/* harmony default export */ __webpack_exports__["a"] = ({

	zoom: 6,
	minZoomMarkers: 10,
	center: [-3.6011, -52.5586],

	miniMap: {
		url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		minZoom: 1,
		maxZoom: 9,
		width: 100,
		height: 100
	},

	baseMaps: [{
		url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
		attribution: 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
		default: true,
		name: 'OpenStreetMap',
		minZoom: 4,
		maxZoom: 18
	}, {
		url: BASE_URL + '/mosaicos/tms?tmsName=rapideye&x={x}&y={y}&z={z}',
		attribution: 'Map data © CAR-Federal',
		default: false,
		tms: true,
		name: 'RapidEye 2011',
		minZoom: 4,
		maxZoom: 15
	}, {
		url: BASE_URL + '/mosaicos/tms?tmsName=landsat&x={x}&y={y}&z={z}',
		attribution: 'Map data © CAR-Federal',
		default: false,
		tms: true,
		name: 'Landsat 2008',
		minZoom: 4,
		maxZoom: 15
	}],

	informacoesSig: 'O Sistema de Informações Geográficas (SIG) permite a visualização, interação e manipulação de informações ' + 'espacialmente referenciadas. Através de uma interface visual simples e intuitiva, o SIG disponibiliza ao ' + 'usuário imagens de satélites, mapas temáticos, camadas com polígonos, pontos, linhas, marcadores de referência,' + 'meta-dados e outras diversas ferramentas como pesquisa, inspeção e exportação de dados.',

	baseReferencia: {
		areaLimiteGeracaoBaseHA: 5000
	},

	inspecao: {
		areaLimiteHA: 5000,
		tamanhoMaximoShapeMB: 10
	}
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Classe responsável mapear os tipos de atributos da camada
*/

var TipoGeometria = function () {
	function TipoGeometria() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TipoGeometria);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TipoGeometria, null, [{
		key: 'getFromGeoJsonType',
		value: function getFromGeoJsonType(type) {

			if (!type) return null;
			type = type.toLowerCase();

			switch (type) {
				case 'point':
				case 'multipoint':
					return this.PONTO;

				case 'linestring':
				case 'multilinestring':
					return this.LINHA;

				case 'polygon':
				case 'multipolygon':
					return this.POLIGONO;

				default:
					return null;
			}
		}
	}, {
		key: 'getFromGeoJson',
		value: function getFromGeoJson(geoJson) {

			if (geoJson.type) {

				var tipo = this.getFromGeoJsonType(geoJson.type);
				if (tipo) return tipo;
			}

			var features = geoJson instanceof Array ? geoJson : geoJson.features;

			if (!features || features.length === 0) return null;

			var geometry = features[0].type === 'Feature' ? features[0].geometry : features[0];

			return this.getFromGeoJsonType(geometry.type);
		}
	}, {
		key: 'POLIGONO',
		get: function get() {
			return {
				nome: 'Polígono',
				codigo: 'POLYGON'
			};
		}
	}, {
		key: 'LINHA',
		get: function get() {
			return {
				nome: 'Linha',
				codigo: 'LINESTRING'
			};
		}
	}, {
		key: 'PONTO',
		get: function get() {
			return {
				nome: 'Ponto',
				codigo: 'POINT'
			};
		}
	}]);

	return TipoGeometria;
}();

/* harmony default export */ __webpack_exports__["a"] = (TipoGeometria);

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__ = __webpack_require__(15);





var COR_DESENHO = '#0066D5';

var COR_INSPECAO = '#FF3232';

var Estilo = function () {
	function Estilo() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Estilo);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Estilo, null, [{
		key: 'toMapStyle',
		value: function toMapStyle(estilo, drawing) {

			var style = {};

			if (estilo.contorno) {
				style.color = estilo.contorno.cor;
				style.weight = estilo.contorno.espessura;
				style.opacity = estilo.contorno.opacidade;
			}

			if (estilo.preenchimento) {
				style.fill = true;
				style.fillColor = estilo.preenchimento.cor;
				style.fillOpacity = estilo.preenchimento.opacidade;
			}

			if (drawing) {
				style.dashArray = '10,10';
				style.weight = 2;
			}

			if (estilo.raio) {
				style.radius = estilo.raio;

				if (drawing) {
					style.dashArray = null;
					style.fill = false;
					style.fillColor = null;
				}
			}

			return style;
		}
	}, {
		key: 'criarEstiloCamadaUsuario',
		value: function criarEstiloCamadaUsuario(cor, tipoGeometria) {

			var estilo = null;

			if (tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].POLIGONO.codigo) {

				estilo = {
					contorno: {
						cor: cor,
						espessura: 1,
						opacidade: 1
					},
					preenchimento: {
						cor: cor,
						opacidade: 0.4
					}
				};
			} else if (tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].LINHA.codigo) {

				estilo = {
					contorno: {
						cor: cor,
						espessura: 2,
						opacidade: 1
					}
				};
			} else if (tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].PONTO.codigo) {

				estilo = {
					contorno: {
						cor: cor,
						espessura: 2,
						opacidade: 1
					},
					preenchimento: {
						cor: cor,
						opacidade: 0.8
					},
					raio: 4
				};
			}

			return estilo;
		}
	}, {
		key: 'getStyleDesenho',
		value: function getStyleDesenho(tipoGeometria, cor) {

			var estilo = this.criarEstiloCamadaUsuario(cor || COR_DESENHO, tipoGeometria);
			return this.toMapStyle(estilo, true);
		}
	}, {
		key: 'getStyleInspecao',
		value: function getStyleInspecao(tipoGeometria, cor) {

			return this.getStyleDesenho(tipoGeometria, cor || COR_INSPECAO);
		}
	}]);

	return Estilo;
}();

/* harmony default export */ __webpack_exports__["a"] = (Estilo);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(221);


/* harmony default export */ __webpack_exports__["a"] = ({

	WMS_URL: __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].baseURL() + '/camadas/wms',

	MAIS_INFORMACOES_URL: __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].baseURL() + '/camadas/{idCamada}/maisInformacoes?id={idRegistro}',

	findAll: function findAll(callback) {

		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get({
			url: '/camadas',
			success: callback
		});
	},
	findInformacoes: function findInformacoes(idsCamadas, wktPonto, callback, errorCallback, options) {

		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post({
			url: '/camadas/informacoes/wkt',
			success: callback,
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: {
				wkt: wktPonto,
				idsCamadas: idsCamadas
			}
		});
	},
	findGrupoInformacoesByWKT: function findGrupoInformacoesByWKT(params, callback, errorCallback, options) {

		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post({
			url: '/camadas/grupoInformacoes/wkt',
			success: function success(data, response) {
				return processarHeadersWkt(response, callback);
			},
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: {
				wkt: params.wkt,
				wktKey: params.wktKey,
				idsCamadas: params.idsCamadas
			}
		});
	},
	findInformacoesByWKT: function findInformacoesByWKT(params, callback, errorCallback, options) {

		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post({
			url: '/camadas/informacoes/wkt',
			success: function success(data, response) {
				return processarHeadersWkt(response, callback);
			},
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: {
				wkt: params.wkt,
				wktKey: params.wktKey,
				idsCamadas: params.idsCamadas,
				pagina: params.pagina
			}
		});
	},
	exportCSVInformacoesCamadaByWKT: function exportCSVInformacoesCamadaByWKT(params, callback, errorCallback, options) {

		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post({
			url: '/camadas/informacoes/csv',
			success: function success(data, response) {
				return processarHeadersWkt(response, callback);
			},
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: {
				wkt: params.wkt,
				wktKey: params.wktKey,
				idsCamadas: params.idsCamadas
			}
		});
	},
	findMarcadores: function findMarcadores(idsCamadas, wktBBox, callback) {

		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get({
			url: '/camadas/marcadores',
			success: callback,
			lockScreen: false,
			data: {
				bbox: wktBBox,
				camadas: idsCamadas && idsCamadas.join(',')
			}
		});
	},
	findRegistroById: function findRegistroById(idCamada, idRegistro, callback, errorCallback, options) {

		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get({
			url: '/camadas/' + idCamada + '/registros/' + idRegistro,
			success: callback,
			error: errorCallback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage
		});
	},
	findAtributos: function findAtributos(idCamada, options, callback) {

		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get({
			url: '/camadas/' + idCamada + '/atributos',
			success: callback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage
		});
	},
	pesquisar: function pesquisar(params, options, callback) {
		return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get({
			url: '/camadas/pesquisa',
			success: callback,
			lockElement: options && options.lockElement,
			lockMessage: options && options.lockMessage,
			data: params

		});
	}
});

var WKT_EXPIRATION_MARGIN = 2 * 60000; // 2 minutos

function processarHeadersWkt(response, callback) {

	var data = {
		data: response.data
	};

	var headers = response && response.headers;

	if (headers) {

		var wktKey = headers['wkt-key'];
		var wxtExpirationSec = headers['wkt-expiration-time-sec'];

		if (wktKey && wxtExpirationSec) {

			data.wktKey = wktKey;
			data.wktExpiration = new Date();
			data.wktExpiration.setTime(data.wktExpiration.getTime() + wxtExpirationSec * 1000 - WKT_EXPIRATION_MARGIN);
		}
	}

	if (callback) callback(data);
};

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__ = __webpack_require__(15);





/* harmony default export */ __webpack_exports__["a"] = ({
	boundsToWKT: function boundsToWKT(bounds) {
		return ['POLYGON((', bounds._southWest.lng, ' ', bounds._southWest.lat, ', ', bounds._southWest.lng, ' ', bounds._northEast.lat, ', ', bounds._northEast.lng, ' ', bounds._northEast.lat, ', ', bounds._northEast.lng, ' ', bounds._southWest.lat, ', ', bounds._southWest.lng, ' ', bounds._southWest.lat, '))'].join('');
	},
	layerToWKT: function layerToWKT(layer) {

		var lng = [];
		var lat = [];
		var coords = [];

		if (layer instanceof __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Polygon || layer instanceof __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Polyline) {

			var latlngs = layer.getLatLngs()[0];

			for (var i = 0; i < latlngs.length; i++) {

				latlngs[i];

				coords.push(latlngs[i].lng + ' ' + latlngs[i].lat);

				if (i === 0) {
					lng = latlngs[i].lng;
					lat = latlngs[i].lat;
				}
			};

			if (layer instanceof __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Polygon) {

				return 'POLYGON((' + coords.join(',') + ',' + lng + ' ' + lat + '))';
			} else if (layer instanceof __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Polyline) {

				return 'LINESTRING(' + coords.join(',') + ')';
			}
		} else if (layer instanceof __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.Marker || layer instanceof __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.CircleMarker) {

			return 'POINT(' + layer.getLatLng().lng + ' ' + layer.getLatLng().lat + ')';
		}
	},
	createGeoJsonLayer: function createGeoJsonLayer(geoJson, style) {

		var tipoGeometria = __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].getFromGeoJson(geoJson);

		if (tipoGeometria.codigo !== __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].PONTO.codigo) {

			return __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.geoJSON(geoJson, { style: style });
		} else {

			return __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.geoJSON(geoJson, {
				pointToLayer: function pointToLayer(feature, latlng) {
					return __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.circleMarker(latlng, style);
				}
			});
		}
	},
	getLayerArea: function getLayerArea(layer) {

		if (layer.getLatLngs) {

			var layerLatlngs = layer.getLatLngs();

			if (!layerLatlngs || !layerLatlngs.length) return 0;

			var area = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.GeometryUtil.geodesicArea(layerLatlngs[0]);

			return area / 10000;
		} else {

			if (!layer.getLayers) return 0;

			var layers = layer.getLayers();

			if (!layers || !layers.length) return 0;

			var total = 0;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(layers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var subLayer = _step.value;


					total += this.getLayerArea(subLayer);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			return total;
		}
	}
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	coordinates: {
		icon: 'map-marker',
		borderColor: '#FFFFFF',
		textColor: '#FFFFFF',
		backgroundColor: '#333333'
	},

	registroCamada: {
		icon: 'map-marker',
		borderColor: '#FFFFFF',
		textColor: '#FFFFFF',
		backgroundColor: '#FF0000'
	},

	inspecao: {
		icon: 'map-marker',
		borderColor: '#FFFFFF',
		textColor: '#FFFFFF',
		backgroundColor: '#FF0000'
	},

	getMarcadorCamada: function getMarcadorCamada(estilo) {
		return {
			iconShape: 'marker',
			icon: estilo.marcador.icone,
			borderColor: 'rgba(255, 255, 255, 0.5)',
			borderWidth: 1,
			textColor: estilo.marcador.corIcone,
			backgroundColor: estilo.marcador.cor
		};
	}
});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(332)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(256),
  /* template */
  __webpack_require__(483),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6a3e461d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(479),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var DrawUtils = function () {
	function DrawUtils() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DrawUtils);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DrawUtils, null, [{
		key: 'RECTANGLE_TOOL',
		get: function get() {
			return 'rectangle';
		}
	}, {
		key: 'POLYGON_TOOL',
		get: function get() {
			return 'polygon';
		}
	}, {
		key: 'POLYLINE_TOOL',
		get: function get() {
			return 'polyline';
		}
	}, {
		key: 'CIRCLEMARKER_TOOL',
		get: function get() {
			return 'circlemarker';
		}
	}, {
		key: 'DEFAULT_COLOR',
		get: function get() {
			return '#0066D5';
		}
	}]);

	return DrawUtils;
}();

/* harmony default export */ __webpack_exports__["a"] = (DrawUtils);
;

/***/ }),
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(239),
  /* template */
  __webpack_require__(465),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(253),
  /* template */
  __webpack_require__(487),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d5c52ef",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(234),
  /* template */
  __webpack_require__(488),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(258),
  /* template */
  __webpack_require__(481),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61f8971e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _latinize = __webpack_require__(357);

/* harmony default export */ __webpack_exports__["a"] = ({
	latinize: function latinize(value) {
		return _latinize(value);
	}
});

/***/ }),
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(328)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(231),
  /* template */
  __webpack_require__(477),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(333)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(248),
  /* template */
  __webpack_require__(485),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(254),
  /* template */
  __webpack_require__(490),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e91a0a56",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(340)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(494),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa2e15da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(317)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(466),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0d81aaa6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_stringUtils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_js__ = __webpack_require__(14);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);



/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
	state: {
		estruturaCamadas: null,
		camadas: null,
		camadasAtivas: null,
		camadasOrdenadas: null,
		idCamadasUsuario: 1,
		grupoCamadasUsuario: null,
		mapa: {
			zoom: __WEBPACK_IMPORTED_MODULE_4__config_js__["a" /* default */].zoom,
			minZoom: 5,
			maxZoom: 17,
			coordinate: null,
			baseMapa: null
		}
	},

	mutations: {
		setMapZoom: function setMapZoom(state, value) {
			state.mapa.zoom = value;
		},
		setMinZoom: function setMinZoom(state, value) {
			state.mapa.minZoom = value;
		},
		setMaxZoom: function setMaxZoom(state, value) {
			state.mapa.maxZoom = value;
		},
		setBaseMap: function setBaseMap(state, value) {
			state.mapa.baseMapa = value;
		},
		setEstruturaCamadas: function setEstruturaCamadas(state, value) {

			state.estruturaCamadas = value || { grupos: [] };
			state.camadas = {};
			state.camadasAtivas = [];
			var camadasOrdenadas = [];

			eachCamada(state.estruturaCamadas, function (c, grupo) {

				c.grupoPai = grupo;
				state.camadas[c.id] = c;
				camadasOrdenadas.push(c);
				if (c.habilitado) state.camadasAtivas.push(c);
			});

			state.camadasOrdenadas = _.orderBy(camadasOrdenadas, [function (c) {
				return __WEBPACK_IMPORTED_MODULE_3__utils_stringUtils__["a" /* default */].latinize(c.nome).toLowerCase();
			}], ['asc']);
		},
		ativarCamada: function ativarCamada(state, camada) {

			if (camada.habilitado) return;
			camada.habilitado = true;
			state.camadasAtivas = _.concat(state.camadasAtivas, camada);
		},
		desativarCamada: function desativarCamada(state, camada) {

			if (!camada.habilitado) return;
			camada.habilitado = false;

			state.camadasAtivas = removerCamada(state.camadasAtivas, camada);
		},
		moverCamadaAtiva: function moverCamadaAtiva(state, options) {

			var currentIndex = _.findIndex(state.camadasAtivas, ['id', options.camada.id]);

			if (currentIndex < 0) return;

			var newList = removerCamada(state.camadasAtivas, options.camada);

			newList.splice(options.index, 0, options.camada);
			state.camadasAtivas = newList;
		},
		setCoordinate: function setCoordinate(state, coordinate) {

			state.mapa.coordinate = coordinate;
		},
		adicionarCamadaUsuario: function adicionarCamadaUsuario(state, camada) {

			state.idCamadasUsuario++;
			camada.id = 'user' + state.idCamadasUsuario;
			camada.camadaUsuario = true;
			camada.habilitado = false;
			state.camadas[camada.id] = camada;

			if (!state.grupoCamadasUsuario) {

				state.grupoCamadasUsuario = {
					nome: 'Minhas camadas',
					cssClass: 'grupo-camadas-usuario',
					camadas: []
				};

				state.estruturaCamadas.grupos.splice(0, 0, state.grupoCamadasUsuario);
			}

			state.grupoCamadasUsuario.camadas.push(camada);
		}
	},

	getters: {
		mapaZoom: function mapaZoom(state) {
			return function (state) {
				return state.mapa.zoom;
			};
		},

		getCamada: function getCamada(state) {
			return function (id) {
				return state.camadas[id];
			};
		},

		camadasAtivasSig: function camadasAtivasSig(state) {
			return _.filter(state.camadasAtivas, function (c) {
				return !c.camadaUsuario;
			});
		}
	}
}));

function removerCamada(camadas, camada) {

	return _.filter(camadas, function (c) {
		return c !== camada && c.id !== camada.id;
	});
}

function eachCamada(grupo, fn) {

	if (grupo.camadas) {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(grupo.camadas), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var camada = _step.value;

				fn(camada, grupo);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}

	if (grupo.grupos) {
		var _iteratorNormalCompletion2 = true;
		var _didIteratorError2 = false;
		var _iteratorError2 = undefined;

		try {
			for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(grupo.grupos), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
				var subGrupo = _step2.value;

				eachCamada(subGrupo, fn);
			}
		} catch (err) {
			_didIteratorError2 = true;
			_iteratorError2 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion2 && _iterator2.return) {
					_iterator2.return();
				}
			} finally {
				if (_didIteratorError2) {
					throw _iteratorError2;
				}
			}
		}
	}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_leaflet__);


__WEBPACK_IMPORTED_MODULE_0_leaflet___default.a.drawLocal = {
	draw: {
		toolbar: {
			actions: {
				title: 'Cancelar desenho',
				text: 'Cancelar'
			},
			finish: {
				title: 'Finalizar desenho',
				text: 'Finalizar'
			},
			undo: {
				title: 'Apagar último ponto desenhado',
				text: 'Apagar último ponto'
			},
			buttons: {
				polyline: 'Desenhar uma linha',
				polygon: 'Desenhar um polígono',
				rectangle: 'Desenhar um retângulo',
				circle: 'Desenhar um círculo',
				marker: 'Desenhar um marcador'
			}
		},
		handlers: {
			circle: {
				tooltip: {
					start: 'Clique e arraste para desenhar um círculo.'
				},
				radius: 'Raio'
			},
			marker: {
				tooltip: {
					start: 'Clique no mapa para posicionar um marcador.'
				}
			},
			circlemarker: {
				tooltip: {
					start: 'Clique no mapa para adicionar um ponto.'
				}
			},
			polygon: {
				tooltip: {
					start: 'Clique para começar a desenhar um polígono.',
					cont: 'Clique para continuar desenhando.',
					end: 'Clique no primeiro ponto para terminar.'
				}
			},
			polyline: {
				error: '<strong>Erro:</strong> arestas não podem se cruzar!',
				tooltip: {
					start: 'Clique para desenhar linha.',
					cont: 'Clique para continuar desenhando.',
					end: 'Clique duas vezes para terminar.'
				}
			},
			rectangle: {
				tooltip: {
					start: 'Clique e arraste para desenhar um retângulo.'
				}
			},
			simpleshape: {
				tooltip: {
					end: 'Solte o botão do mouse para terminar.'
				}
			}
		}
	},
	edit: {
		toolbar: {
			actions: {
				save: {
					title: 'Salvar mudanças.',
					text: 'Salvar'
				},
				cancel: {
					title: 'Cancelar edição, descartar mudanças.',
					text: 'Cancelar'
				}
			},
			buttons: {
				edit: 'Editar camada.',
				editDisabled: 'Sem camadas para editar.',
				remove: 'Apagar desenho.',
				removeDisabled: 'Sem camadas para apagar.'
			}
		},
		handlers: {
			edit: {
				tooltip: {
					text: 'Arraste os quadrados, ou marcador para editar.',
					subtext: 'Clique cancelar para desfazer.'
				}
			},
			remove: {
				tooltip: {
					text: 'Clique em um desenho para remover.'
				}
			}
		}
	}
};

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vee_validate__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__messages__ = __webpack_require__(219);





var customRuleCount = 0;

// Configurando Locale
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */].Validator.addLocale(__WEBPACK_IMPORTED_MODULE_2__messages__["a" /* default */].validation);

// Método para adicionar validação customizada para componente
__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */].Validator.prototype.addComponentRule = function (vm, customRule) {

	if (!vm.$el) {
		return;
	}

	var fieldId = vm.$el.getAttribute('data-vv-id');

	if (!fieldId) {

		console.error('Ainda não implementado o tratamento para este caso.');
		return;
	} else {

		customRuleCount++;
		var field = this.fields.find({ id: fieldId });
		var ruleName = 'custom_rule_' + (vm.$options && vm.$options.name || '') + field.id + '_' + customRuleCount;
		this.extend(ruleName, customRule);
		field.rules = field.rules || {};
		field.rules[ruleName] = [];
		field.update({ rules: field.rules });
	}
};

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */].Validator.prototype.cleanErrors = function (names) {

	if (names) {
		names = names instanceof Array ? names : [names];
	}

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.fields.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var field = _step.value;


			if (!names || names.includes(field.name)) {

				this.errors.removeById(field.id);
				field.flags.invalid = false;
				field.flags.valid = true;
				field.updateClasses();
			}
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
};

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */].Validator.extend('latitude', {
	getMessage: function getMessage(field) {
		return 'Latitude inválida.';
	},
	validate: function validate(value) {

		var regex = /^(?:-|-?(?:\d|[1-8]\d?|90?)(?:\.[0-9]{0,6})?)$/;

		return regex.test(value);
	}
});

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */].Validator.extend('longitude', {
	getMessage: function getMessage(field) {
		return 'Longitude inválida.';
	},
	validate: function validate(value) {

		var regex = /^(?:-|-?(?:\d|[1-9]\d?|1(?:[0-7]\d?)?|1(?:80?)?)(?:\.[0-9]{0,6})?)$/;

		return regex.test(value);
	}
});

__WEBPACK_IMPORTED_MODULE_1_vee_validate__["a" /* default */].Validator.extend('numeroInteiro', {
	getMessage: function getMessage(field) {
		return 'Só é permitido inserir números.';
	},
	validate: function validate(value) {

		var regex = /^(-?[1-9]+\d*)$|^0$/;

		return regex.test(value);
	}
});

/***/ }),
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 174 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(227),
  /* template */
  __webpack_require__(474),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-25441132",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_pt_br__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_pt_br___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_pt_br__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_index__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils_InputErrors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils_InputErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_utils_InputErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_leaflet_draw_pt_br_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_sweetalert__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__validations__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_leaflet_dist_leaflet_css__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_leaflet_dist_leaflet_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_leaflet_dist_leaflet_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_leaflet_draw_dist_leaflet_draw_src_css__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_leaflet_draw_dist_leaflet_draw_src_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_leaflet_draw_dist_leaflet_draw_src_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_leaflet_minimap_src_Control_MiniMap_css__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_leaflet_minimap_src_Control_MiniMap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_leaflet_minimap_src_Control_MiniMap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_font_awesome_css_font_awesome_css__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mdi_css_materialdesignicons_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_mdi_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_mdi_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_fonts_lemaf_lemaf_css__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_fonts_lemaf_lemaf_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_fonts_lemaf_lemaf_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_leaflet_beautify_marker_icon_css__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__styles_leaflet_beautify_marker_icon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__styles_leaflet_beautify_marker_icon_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_leaflet_contextmenu_dist_leaflet_contextmenu_min_css__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_leaflet_contextmenu_dist_leaflet_contextmenu_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_leaflet_contextmenu_dist_leaflet_contextmenu_min_css__);
__webpack_require__(21);
__webpack_require__(162);
__webpack_require__(161);













// Imports CSS












// Configurações Vue
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('input-errors', __WEBPACK_IMPORTED_MODULE_6__components_utils_InputErrors___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_pt_br___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */], { classes: true, locale: 'pt_BR' });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_sweetalert___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_4__store_index__["a" /* default */],
	template: '<App/>',
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/* Hot reload para o Vuex */
if (false) {

	module.hot.accept(['./store/index'], function () {

		var newStore = require('./store/index').default;
		store.hotUpdate(newStore);
	});
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	// Internacionalização das mensagens do Vee-validate (http://vee-validate.logaretm.com/localization.html#translation)
	validation: {
		name: 'pt_BR',
		messages: {
			min_value: function min_value(e, n) {
				return 'O valor mínimo é ' + n[0] + '.';
			},
			max_value: function max_value(e, n) {
				return 'O valor máximo é ' + n[0] + '.';
			},
			latitude: function latitude() {
				return 'Látitude inválida.';
			},
			longitude: function longitude() {
				return 'Longitude inválida.';
			},
			required: function required() {
				return 'Campo obrigatório.';
			},
			email: function email() {
				return 'Email inválido.';
			},
			confirmed: function confirmed(e, n) {
				return 'O campo ' + e + ' não é igual ao ' + n;
			},
			decimal: 'O campo deve ser um número decimal válido. Ex: 12.32',
			date_format: 'Data inválida ou não está no padrão dia/mês/ano',
			numeroInteiro: function numeroInteiro() {
				return 'O campo deve ser número inteiro. Ex: 232 ';
			}
		},
		custom: {
			areaHa: {
				max_value: function max_value(e, n) {
					return 'O limite máximo permitido é ' + n[0] + ' ha.';
				}
			}
		}
	}
});

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Classe responsável mapear os tipos de atributos da camada
*/

var TipoAtributoCamada = function () {
	function TipoAtributoCamada() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, TipoAtributoCamada);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(TipoAtributoCamada, null, [{
		key: 'BOOLEANO',
		get: function get() {
			return 'BOOLEANO';
		}
	}, {
		key: 'DATA',
		get: function get() {
			return 'DATA';
		}
	}, {
		key: 'DECIMAL',
		get: function get() {
			return 'DECIMAL';
		}
	}, {
		key: 'INTEIRO',
		get: function get() {
			return 'INTEIRO';
		}
	}, {
		key: 'TEXTO',
		get: function get() {
			return 'TEXTO';
		}
	}, {
		key: 'OUTROS',
		get: function get() {
			return 'OUTROS';
		}
	}]);

	return TipoAtributoCamada;
}();

/* harmony default export */ __webpack_exports__["a"] = (TipoAtributoCamada);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_loading__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);





// A propriedade process.env.APPLICATION_PATH é buscada da configuração do projeto
// e é gerenciada pelo webpack. É uma forma de criar variáveis de confuguração de acordo
// com o ambiente em que a aplicação está sendo executada.
// config/dev.env.js ~> ambiente de desenvolvimento
// config/prod.env.js ~> ambiente de produção
var BASE_URL = "/sigerh/sig";

__WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.timeout = 3600000;

var Http = function () {
	function Http() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Http);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Http, null, [{
		key: 'baseURL',
		value: function baseURL() {
			return BASE_URL;
		}
	}, {
		key: '_getOptionValue',
		value: function _getOptionValue(options, prop, defaultValue) {

			if (!options || !options.hasOwnProperty(prop)) {
				return defaultValue;
			} else {
				return options[prop];
			}
		}
	}, {
		key: '_handleRequestPromisse',
		value: function _handleRequestPromisse(promisse, options) {

			promisse.then(function (response) {

				if (options.lockScreen) {
					Http._hideLoading(options);
				}

				if (options.success) {
					options.success(response.data, response);
				}
			}).catch(function (error) {

				if (options.error) {

					options.error(error.response.data);
				}

				if (options.lockScreen) {
					Http._hideLoading(options);
				}
			});
		}
	}, {
		key: '_setDefaultOptions',
		value: function _setDefaultOptions(options) {

			options = options || {};
			options.fullUrl = BASE_URL + options.url;
			options.lockScreen = Http._getOptionValue(options, 'lockScreen', true);
			options.lockMessage = options.lockMessage || 'Carregando';

			return options;
		}
	}, {
		key: '_showLoading',
		value: function _showLoading(options) {

			__WEBPACK_IMPORTED_MODULE_2__utils_loading__["a" /* default */].show(options.lockMessage, options.lockElement);
		}
	}, {
		key: '_hideLoading',
		value: function _hideLoading(options) {

			__WEBPACK_IMPORTED_MODULE_2__utils_loading__["a" /* default */].hide(options.lockElement);
		}
	}, {
		key: 'get',
		value: function get(options) {

			options = Http._setDefaultOptions(options);

			if (options.lockScreen) {
				Http._showLoading(options);
			}

			var promisse = options.data ? __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(options.fullUrl, { params: options.data }) : __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(options.fullUrl);

			Http._handleRequestPromisse(promisse, options);

			return promisse;
		}
	}, {
		key: 'post',
		value: function post(options) {

			options = Http._setDefaultOptions(options);

			if (options.lockScreen) {
				Http._showLoading(options);
			}

			var promisse = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(options.fullUrl, options.data);

			Http._handleRequestPromisse(promisse, options);

			return promisse;
		}
	}, {
		key: 'delete',
		value: function _delete(options) {

			options = Http._setDefaultOptions(options);

			if (options.lockScreen) {
				Http._showLoading(options);
			}

			var promisse = options.data ? __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(options.fullUrl, { params: options.data }) : __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(options.fullUrl);

			Http._handleRequestPromisse(promisse, options);

			return promisse;
		}
	}, {
		key: 'put',
		value: function put(options) {

			options = Http._setDefaultOptions(options);

			if (options.lockScreen) {
				Http._showLoading(options);
			}

			var promisse = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(options.fullUrl, options.data);

			Http._handleRequestPromisse(promisse, options);

			return promisse;
		}
	}]);

	return Http;
}();

/* harmony default export */ __webpack_exports__["a"] = (Http);
;

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);




var CustomBoxZoom = function () {
	function CustomBoxZoom(map, options) {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CustomBoxZoom);

		this._map = map;
		this._enabled = false;
		this._configure();
		this._onDisabled = options && options.onDisabled;
		this._onEnabled = options && options.onEnabled;
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CustomBoxZoom, [{
		key: 'enable',
		value: function enable() {

			this._map._container.style.cursor = 'crosshair';
			this._enabled = true;

			if (this._onEnabled) {
				this._onEnabled();
			}
		}
	}, {
		key: 'disable',
		value: function disable() {

			if (this._enabled) {

				this._enabled = false;
				this._map.dragging.enable();
				this._map.boxZoom._container.style.cursor = '';

				if (this._onDisabled) {
					this._onDisabled();
				}
			}
		}
	}, {
		key: '_configure',
		value: function _configure() {

			var boxZoom = this._map.boxZoom;
			var that = this;

			this._map.on('mousedown', function (e) {

				e = e.originalEvent;

				if (!that._enabled || e.which !== 1 && e.button !== 1) {
					return false;
				}

				boxZoom._clearDeferredResetState();
				boxZoom._resetState();

				that._map.dragging.disable();
				__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.DomUtil.disableTextSelection();
				__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.DomUtil.disableImageDrag();

				boxZoom._startPoint = boxZoom._map.mouseEventToContainerPoint(e);

				__WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.DomEvent.on(document, {
					contextmenu: __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.DomEvent.stop,
					mousemove: boxZoom._onMouseMove,
					mouseup: function mouseup(e) {
						boxZoom._onMouseUp(e);
						that.disable();
					},
					keydown: boxZoom._onKeyDown
				}, boxZoom);
			});
		}
	}]);

	return CustomBoxZoom;
}();

/* harmony default export */ __webpack_exports__["a"] = (CustomBoxZoom);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);




var DETAILS_GEOMETRY_TYPE_FLAGS = {
	Point: 'isPoint',
	MultiPoint: 'isPoint',
	LineString: 'isLineString',
	MultiLineString: 'isLineString',
	Polygon: 'isPolygon',
	MultiPolygon: 'isPolygon'
};

var GeoJsonUtil = function () {
	function GeoJsonUtil() {
		__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, GeoJsonUtil);
	}

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(GeoJsonUtil, null, [{
		key: '_getDetailsRecursive',
		value: function _getDetailsRecursive(geoJson, details) {

			if (!geoJson || !geoJson.type) return;

			switch (geoJson.type) {

				case 'FeatureCollection':

					if (!geoJson.features || !geoJson.features.length) return;

					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;

					try {
						for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(geoJson.features), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var feature = _step.value;


							this._getDetailsRecursive(feature, details);
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}

					return;

				case 'Feature':

					this._getDetailsRecursive(geoJson.geometry, details);
					return;

				case 'Point':
				case 'LineString':
				case 'Polygon':

					this._setDetailsGemetryType(details, geoJson.type);
					details.totalGeometries++;

					if (!details.firstGeometry) details.firstGeometry = geoJson;

					return;

				case 'MultiPoint':
				case 'MultiLineString':
				case 'MultiPolygon':

					this._setDetailsGemetryType(details, geoJson.type);
					details.totalGeometries += geoJson.coordinates.length;

					if (!details.firstGeometry) details.firstGeometry = geoJson;

					return;
			}
		}
	}, {
		key: '_setDetailsGemetryType',
		value: function _setDetailsGemetryType(details, type) {

			if (details.geometryTypes.indexOf(type) === -1) {

				var flag = DETAILS_GEOMETRY_TYPE_FLAGS[type];
				details[flag] = true;
				details.geometryTypes.push(type);
			}
		}

		/**
   * Método que extrai alguns detalhes sobre o geoJson, como o número
   * de geometrias e quais os tipos de geometria contidos nele.
   */

	}, {
		key: 'getDetails',
		value: function getDetails(geoJson) {

			var details = {
				isPolygon: false,
				isPoint: false,
				isLineString: false,
				geometryTypes: [],
				totalGeometries: 0,
				firstGeometry: null
			};

			if (!geoJson || !geoJson.type) return details;

			this._getDetailsRecursive(geoJson, details);

			return details;
		}
	}, {
		key: 'getFirstGeometry',
		value: function getFirstGeometry(geojson) {

			var details = this.getDetails(geojson);

			return details.firstGeometry;
		}
	}]);

	return GeoJsonUtil;
}();

/* harmony default export */ __webpack_exports__["a"] = (GeoJsonUtil);
;

/***/ }),
/* 224 */
/***/ (function(module, exports) {

/* Leaflet.BeautifyIcon, a plugin that adds colorful iconic markers for Leaflet by giving full control of style to end user, It has also ability to adjust font awesome
 * and glyphicon icons
 * (c) 2016-2017, Muhammad Arslan Sajid
 * http://leafletjs.com
 */

/* global L of leaflet*/

(function (window, document, undefined) {

	'use strict';

	/*
 * Leaflet.BeautifyIcon assumes that you have already included the Leaflet library.
 */

	/*
 * Default settings for various style markers
 */

	var defaults = {

		iconColor: '#1EB300',

		iconAnchor: {
			'marker': [14, 36],
			'circle': [11, 10],
			'circle-dot': [5, 5],
			'rectangle-dot': [5, 6],
			'doughnut': [8, 8]
		},

		popupAnchor: {
			'marker': [0, -25],
			'circle': [-3, -76],
			'circle-dot': [0, -2],
			'rectangle-dot': [0, -2],
			'doughnut': [0, -2]
		},

		innerIconAnchor: {
			'marker': [-2, 5],
			'circle': [0, 2]
		},

		iconSize: {
			'marker': [28, 28],
			'circle': [22, 22],
			'circle-dot': [2, 2],
			'rectangle-dot': [2, 2],
			'doughnut': [15, 15]
		}
	};

	L.BeautifyIcon = {

		Icon: L.Icon.extend({

			options: {
				icon: 'leaf',
				iconSize: defaults.iconSize.circle,
				iconAnchor: defaults.iconAnchor.circle,
				iconShape: 'circle',
				iconStyle: '',
				innerIconAnchor: [0, 3], // circle with fa or glyphicon or marker with text
				innerIconStyle: '',
				isAlphaNumericIcon: false,
				text: 1,
				borderColor: defaults.iconColor,
				borderWidth: 2,
				borderStyle: 'solid',
				backgroundColor: 'white',
				textColor: defaults.iconColor,
				customClasses: '',
				spin: false,
				prefix: 'fa',
				html: ''
			},

			initialize: function initialize(options) {

				this.applyDefaults(options);
				this.options = L.Util.setOptions(this, options);
			},

			applyDefaults: function applyDefaults(options) {

				if (options) {
					if (!options.iconSize && options.iconShape) {
						options.iconSize = defaults.iconSize[options.iconShape];
					}

					if (!options.iconAnchor && options.iconShape) {
						options.iconAnchor = defaults.iconAnchor[options.iconShape];
					}

					if (!options.popupAnchor && options.iconShape) {
						options.popupAnchor = defaults.popupAnchor[options.iconShape];
					}

					if (!options.innerIconAnchor) {
						// if icon is type of circle or marker
						if (options.iconShape === 'circle' || options.iconShape === 'marker') {
							if (options.iconShape === 'circle' && options.isAlphaNumericIcon) {
								// if circle with text
								options.innerIconAnchor = [0, -1];
							} else if (options.iconShape === 'marker' && !options.isAlphaNumericIcon) {
								// marker with icon
								options.innerIconAnchor = defaults.innerIconAnchor[options.iconShape];
							}
						}
					}
				}
			},

			createIcon: function createIcon() {

				var iconDiv = document.createElement('div'),
				    options = this.options;

				iconDiv.innerHTML = !options.html ? this.createIconInnerHtml() : options.html;
				this._setIconStyles(iconDiv);

				// having a marker requires an extra parent div for rotation correction
				if (this.options.iconShape === 'marker') {
					var wrapperDiv = document.createElement('div');
					wrapperDiv.appendChild(iconDiv);
					return wrapperDiv;
				}

				return iconDiv;
			},

			createIconInnerHtml: function createIconInnerHtml() {

				var options = this.options;

				if (options.iconShape === 'circle-dot' || options.iconShape === 'rectangle-dot' || options.iconShape === 'doughnut') {
					return '';
				}

				var innerIconStyle = this.getInnerIconStyle(options);
				if (options.isAlphaNumericIcon) {
					return '<div style="' + innerIconStyle + '">' + options.text + '</div>';
				}

				var spinClass = '';
				if (options.spin) {
					spinClass = ' fa-spin';
				}

				var iconClass = options.prefix ? options.prefix + ' ' + options.prefix + '-' + options.icon : options.icon;

				return '<i class="' + iconClass + spinClass + '" style="' + innerIconStyle + '"></i>';
			},

			getInnerIconStyle: function getInnerIconStyle(options) {

				var innerAnchor = L.point(options.innerIconAnchor);
				return 'color:' + options.textColor + ';margin-top:' + innerAnchor.y + 'px; margin-left:' + innerAnchor.x + 'px;' + options.innerIconStyle;
			},

			_setIconStyles: function _setIconStyles(iconDiv) {

				var options = this.options,
				    size = L.point(options.iconSize),
				    anchor = L.point(options.iconAnchor);

				iconDiv.className = 'beautify-marker ';

				if (options.iconShape) {
					iconDiv.className += options.iconShape;
				}

				if (options.customClasses) {
					iconDiv.className += ' ' + options.customClasses;
				}

				iconDiv.style.backgroundColor = options.backgroundColor;
				iconDiv.style.color = options.textColor;
				iconDiv.style.borderColor = options.borderColor;
				iconDiv.style.borderWidth = options.borderWidth + 'px';
				iconDiv.style.borderStyle = options.borderStyle;

				if (size) {
					iconDiv.style.width = size.x + 'px';
					iconDiv.style.height = size.y + 'px';
				}

				if (anchor) {
					iconDiv.style.marginLeft = -anchor.x + 'px';
					iconDiv.style.marginTop = -anchor.y + 'px';
				}

				if (options.iconStyle) {
					var cStyle = iconDiv.getAttribute('style');
					cStyle += options.iconStyle;
					iconDiv.setAttribute('style', cStyle);
				}
			}
		})
	};

	L.BeautifyIcon.icon = function (options) {
		return new L.BeautifyIcon.Icon(options);
	};
})(this, document);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_minimap__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_leaflet_minimap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_leaflet_minimap__);






var MiniMapa = function () {
	function MiniMapa(mapa) {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MiniMapa);

		this._mapa = mapa;
		this._configure();
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(MiniMapa, [{
		key: '_configure',
		value: function _configure() {

			var omsMini = new __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.TileLayer(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].miniMap.url, {
				minZoom: __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].miniMap.minZoom,
				maxZoom: __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].miniMap.maxZoom
			});

			var miniMapOptions = {
				width: __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].miniMap.width,
				height: __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */].miniMap.height,
				collapsedWidth: 20,
				collapsedHeight: 20,
				toggleDisplay: true,
				position: 'bottomleft',
				strings: {
					hideText: 'Esconder minimapa',
					showText: 'Mostrar minimapa'
				}
			};

			new __WEBPACK_IMPORTED_MODULE_4_leaflet_minimap___default.a(omsMini, miniMapOptions).addTo(this._mapa);
		}
	}]);

	return MiniMapa;
}();

/* harmony default export */ __webpack_exports__["a"] = (MiniMapa);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Loading = function () {
	function Loading() {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Loading);
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Loading, null, [{
		key: '_getSpinnerHTML',
		value: function _getSpinnerHTML(msg) {

			return '<div class="spinner">' + '<div class="rect1"></div>' + '<div class="rect2"></div>' + '<div class="rect3"></div>' + '<div class="rect4"></div>' + '<div class="rect5"></div>' + '</div>' + '<span class="spinner-text">' + msg + '</span>';
		}
	}, {
		key: 'show',
		value: function show(msg, element) {

			msg = msg || 'Carregando';

			var options = {
				message: this._getSpinnerHTML(msg),
				baseZ: 10000,
				overlayCSS: {
					backgroundColor: '#FFFFFF',
					opacity: 0.8,
					cursor: 'wait'
				},
				css: {
					backgroundColor: 'transparent',
					border: 'none'
				}
			};

			if (!element) {

				$.blockUI(options);
			} else {

				options.css.width = '100%';
				$(element).block(options);
			}
		}
	}, {
		key: 'hide',
		value: function hide(element) {

			if (!element) {
				$.unblockUI();
			} else {
				$(element).unblock();
			}
		}
	}]);

	return Loading;
}();

/* harmony default export */ __webpack_exports__["a"] = (Loading);
;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Mapa__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Mapa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Mapa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ToolBox__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ToolBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ToolBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SearchBox__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SearchBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_SearchBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pesquisa__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pesquisa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Pesquisa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_inspecao_InformacoesPonto__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_inspecao_InformacoesPonto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_inspecao_InformacoesPonto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_inspecao_Inspecao__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_inspecao_Inspecao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_inspecao_Inspecao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Zoom__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Zoom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_camadas_Camadas__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_camadas_Camadas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_camadas_Camadas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_adicaoCamadas_AdicaoCamadas__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_adicaoCamadas_AdicaoCamadas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_adicaoCamadas_AdicaoCamadas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BottomBar__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_BottomBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_BottomBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_camadasService__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'app',

	components: { Mapa: __WEBPACK_IMPORTED_MODULE_2__components_Mapa___default.a, ToolBox: __WEBPACK_IMPORTED_MODULE_3__components_ToolBox___default.a, SigHeader: __WEBPACK_IMPORTED_MODULE_1__components_Header___default.a, BottomBar: __WEBPACK_IMPORTED_MODULE_11__components_BottomBar___default.a, SearchBox: __WEBPACK_IMPORTED_MODULE_4__components_SearchBox___default.a },

	data: function data() {
		return {
			tools: [__WEBPACK_IMPORTED_MODULE_8__components_Zoom___default.a, __WEBPACK_IMPORTED_MODULE_9__components_camadas_Camadas___default.a, __WEBPACK_IMPORTED_MODULE_10__components_adicaoCamadas_AdicaoCamadas___default.a],
			searchTools: [__WEBPACK_IMPORTED_MODULE_5__components_Pesquisa___default.a, __WEBPACK_IMPORTED_MODULE_6__components_inspecao_InformacoesPonto___default.a, __WEBPACK_IMPORTED_MODULE_7__components_inspecao_Inspecao___default.a],
			config: __WEBPACK_IMPORTED_MODULE_12__config_js__["a" /* default */]
		};
	},
	created: function created() {

		this.initializeGlobalMapVariables();

		this.disableDefaultRightClickAction();
	},
	mounted: function mounted() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_13__services_camadasService__["a" /* default */].findAll(function (data) {
			return _this.setEstruturaCamadas(data);
		});
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		initializeGlobalMapVariables: function initializeGlobalMapVariables() {

			this.setMinZoom(this.initialBaseMap.minZoom);
			this.setMaxZoom(this.initialBaseMap.maxZoom);

			this.setCoordinate({
				lat: this.config.center[0],
				lng: this.config.center[1]
			});
		},
		disableDefaultRightClickAction: function disableDefaultRightClickAction() {

			// Bloqueia o comportamento default dos navegadores ao utilizar o botão direito do mouse
			$('html').bind('contextmenu', function (e) {
				return false;
			});
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14_vuex__["a" /* mapMutations */])(['setMinZoom', 'setMaxZoom', 'setEstruturaCamadas', 'setCoordinate'])),

	computed: {
		initialBaseMap: function initialBaseMap() {
			return _.find(this.config.baseMaps, function (baseMap) {
				return baseMap.default;
			});
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21), __webpack_require__(10)))

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'BaseMapSelect',

	data: function data() {
		return {
			baseMaps: __WEBPACK_IMPORTED_MODULE_1__config_js__["a" /* default */].baseMaps,
			showOptions: false,
			selectedBaseMap: null
		};
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		changeBaseMap: function changeBaseMap(baseMap) {

			this.showOptions = false;

			if (this.selectedBaseMap === baseMap) return;

			this.selectedBaseMap = baseMap;
			this.setBaseMap(baseMap);
			this.$bus.$emit('mapa.changeBaseMap', baseMap);
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapMutations */])(['setBaseMap'])),

	mounted: function mounted() {

		this.selectedBaseMap = _.find(this.baseMaps, function (baseMap) {
			return baseMap.default;
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseMapSelect__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_BaseMapSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_BaseMapSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Coordinates__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Coordinates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Coordinates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ZoomSelect__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ZoomSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ZoomSelect__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'BottomBar',

	components: { BaseMapSelect: __WEBPACK_IMPORTED_MODULE_0__components_BaseMapSelect___default.a, Coordinates: __WEBPACK_IMPORTED_MODULE_1__components_Coordinates___default.a, ZoomSelect: __WEBPACK_IMPORTED_MODULE_2__components_ZoomSelect___default.a }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_markerStyles__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'Coordinates',

	data: function data() {
		return {

			expanded: false,

			options: [{
				id: 1,
				label: 'Latitude / Longitude geográfico'
			}, {
				id: 2,
				label: 'GMS geográfico'
			}],

			value: {
				id: 1
			},

			latitude: null,

			longitude: null
		};
	},


	computed: {
		coordinate: function coordinate() {

			return this.$store.state.mapa.coordinate;
		}
	},

	methods: {
		showCoordinates: function showCoordinates() {

			if (this.latitude && this.longitude) {

				this.$bus.$emit('mapa.addCoordinatePoint', {
					markerCode: 'CoordinatesComponent',
					lat: this.latitude,
					lng: this.longitude,
					markerStyle: __WEBPACK_IMPORTED_MODULE_0__utils_markerStyles__["a" /* default */].coordinates,
					center: true,
					inspecionar: true
				});
			}

			this.close();
		},
		close: function close() {

			this.longitude = null;
			this.latitude = null;
			this.$validator.reset();
			this.expanded = false;
		}
	}
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'FloatBox',

	props: {
		tools: Array
	},

	data: function data() {
		return {
			expanded: false,
			buttons: [],
			viewComponents: [],
			currentComponent: null,
			contentTitle: '',
			contentTitleIconClass: null
		};
	},


	methods: {
		toogle: function toogle() {
			this.expanded = !this.expanded;
		},
		collapse: function collapse() {
			this.expanded = false;
		},
		changeComponent: function changeComponent(componentClass, callback) {
			var _this = this;

			var viewChanged = this.currentComponent !== componentClass.name;
			var lastComponent = this.getComponentByName(this.currentComponent);

			// Se este componente já estiver aberto, contrair o menu
			if (this.expanded && !viewChanged) {

				this.collapse(); // TODO TRATAR ESSE COLAPSE
				return;
			}

			// Se alterou o componente, chamar o método "beforeComponentHide" do
			// componente anterior, antes de substituí-lo pelo novo.
			if (viewChanged && lastComponent && lastComponent.beforeComponentHide) {

				lastComponent.beforeComponentHide();
			}

			this.expanded = true;
			this.currentComponent = componentClass.name;
			this.contentTitle = componentClass.componentOptions.title;
			this.contentTitleIconClass = componentClass.componentOptions.titleIconClass;

			var newComponent = this.getComponentByName(this.currentComponent);

			if (newComponent) {

				if (viewChanged && newComponent.afterComponentShow) {

					newComponent.afterComponentShow();
				}

				if (callback) callback(newComponent);
			} else {

				this.$nextTick(function () {

					newComponent = _this.getComponentByName(_this.currentComponent);

					if (newComponent) {

						if (newComponent.afterComponentShow) newComponent.afterComponentShow();

						if (callback) callback(newComponent);
					}
				});
			}
		},


		// Executa a ação de um dos botões. Se a action informada no parâmetro
		// podendo expandir a barra de conteúdo (action.showView) e/ou executar
		// uma função do componente (action.action)
		callAction: function callAction(action) {

			if (action.showView) {

				this.changeComponent(action.componentClass);
			}

			if (action.action) {

				var component = this.$refs[action.componentClass.name][0];
				component[action.action]();
			}
		},
		getComponentByName: function getComponentByName(name) {

			if (!name || !this.$refs[name]) return null;

			return this.$refs[name][0];
		},
		getCurrentComponent: function getCurrentComponent() {

			return this.currentComponent && this.$refs[this.currentComponent] && this.$refs[this.currentComponent][0];
		},


		// Adiciona um componente à barra de ferramentas. ComponentClass deve
		// ser uma definição de componente Vue e deve possuir o atributo:
		// "componentOptions: { title: 'Título', actions: [] }".
		// Actions é um array contendo arrays (grupos) de objetos (actions).
		// Cada action é um botão a ser adicionado na barra e possui a estrutura:
		// { name: 'Camadas', iconClass: 'fa fa-bars', action: () => this.show(); showView: true }
		configureComponent: function configureComponent(componentClass) {
			var _this2 = this;

			var options = componentClass.componentOptions;
			var errorMsg = 'Erro ao carregar o componente ' + componentClass.name + '. ';

			if (!options) {

				errorMsg += 'O componente não possui a propriedade "componentOptions".';
				throw errorMsg;
			}

			this.viewComponents.push(componentClass);

			// Configurando as action do componente, que são as ações acionadas através
			// dos botões da barra de ferramentas.
			if (options.actions) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {

					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(options.actions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var actionGroup = _step.value;
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {

							for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(actionGroup), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var action = _step2.value;


								action.componentClass = componentClass;
								options.titleIconClass = options.titleIconClass || action.iconClass;

								if (action.showView && !options.title) {

									errorMsg += 'O componente não possui a propriedade "componentOptions.title".';
									throw errorMsg;
								}
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}

			this.buttons = this.buttons.concat(options.actions);

			// Configurando os eventos que devem ser tratados pelo componente. Estes eventos devem ser
			// disparados através do barramento ($bus).
			if (options.events) {
				var _loop = function _loop(event) {

					_this2.$bus.$on(event, function (e) {
						return _this2.handleComponentEvent(e, componentClass, options.events[event]);
					});
				};

				for (var event in options.events) {
					_loop(event);
				}
			}
		},
		handleComponentEvent: function handleComponentEvent(event, componentClass, handlerName) {

			if (this.currentComponent === componentClass.name) {

				this.getCurrentComponent()[handlerName](event);
			} else {

				this.changeComponent(componentClass, function (component) {

					component[handlerName](event);
				});
			}
		},
		closeCurrentComponent: function closeCurrentComponent() {

			var component = this.getCurrentComponent();

			if (component && component.beforeComponentHide) {

				component.beforeComponentHide();
			}

			this.currentComponent = null;
			this.contentTitle = null;
			this.contentTitleIconClass = null;

			this.collapse();
		}
	},

	created: function created() {

		if (!this.tools) return;

		var _iteratorNormalCompletion3 = true;
		var _didIteratorError3 = false;
		var _iteratorError3 = undefined;

		try {
			for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tools), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
				var componentClass = _step3.value;


				this.configureComponent(componentClass);
			}
		} catch (err) {
			_didIteratorError3 = true;
			_iteratorError3 = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion3 && _iterator3.return) {
					_iterator3.return();
				}
			} finally {
				if (_didIteratorError3) {
					throw _iteratorError3;
				}
			}
		}
	}
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SigHeader',

	data: function data() {

		return {
			expanded: false,
			informacoes: __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].informacoesSig
		};
	}
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ListagemGruposRegistrosCamada',

	props: {
		grupos: Array
	},

	components: { EmptyResult: __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult___default.a },

	methods: {
		exibirGrupo: function exibirGrupo(grupo) {

			this.$emit('exibirGrupo', { grupo: grupo });
		}
	}
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_markerStyles__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var MARKER_CODE = 'InformacoesPontoComponent';

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ListagemRegistrosCamada',

	components: { EmptyResult: __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult___default.a },

	props: {
		registros: Array,
		showMarkers: Boolean
	},

	methods: {
		exibirRegistro: function exibirRegistro(registro) {

			this.$emit('exibirRegistro', { registro: registro });
		},
		onRegistroMouseEnter: function onRegistroMouseEnter(reg) {

			if (this.showMarkers && reg.centroid) {

				this.$bus.$emit('mapa.addCoordinatePoint', {
					markerCode: MARKER_CODE,
					lat: reg.centroid.coordinates[1],
					lng: reg.centroid.coordinates[0],
					markerStyle: __WEBPACK_IMPORTED_MODULE_1__utils_markerStyles__["a" /* default */].registroCamada,
					center: false
				});
			}
		},
		onResultadosMouseLeave: function onResultadosMouseLeave() {

			if (this.showMarkers && this.registros && this.registros.length) {
				this.removerMarcador(MARKER_CODE);
			}
		},
		removerMarcador: function removerMarcador() {
			this.$bus.$emit('mapa.removeCoordinatePoint', MARKER_CODE);
		},
		limpar: function limpar() {
			this.removerMarcador();
		}
	}
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_leafletUtils__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_draw_dist_leaflet_draw_src_js__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_leaflet_draw_dist_leaflet_draw_src_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_leaflet_draw_dist_leaflet_draw_src_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_leaflet_beaultify_marker_icon_js__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_leaflet_beaultify_marker_icon_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__utils_leaflet_beaultify_marker_icon_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_customBoxZoom__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_leaflet_minimap__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_camadasService__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_leaflet_contextmenu_dist_leaflet_contextmenu_min_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_leaflet_contextmenu_dist_leaflet_contextmenu_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_leaflet_contextmenu_dist_leaflet_contextmenu_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_markerStyles__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__models_estilo__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_drawUtils__ = __webpack_require__(45);


//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'Mapa',

	data: function data() {
		return {
			mapa: null,
			selectedBaseMap: null,
			baseMapLayer: null,
			boxZoom: null,
			markers: {},
			miniMapa: null,
			draw: {
				tools: {},
				layer: null,
				options: null
			},
			layers: {},
			layersMarkersActive: false
		};
	},


	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({

		/**
   * Responsável pela criação inicial do mapa,
   * - Cria a configuração default do mapa
   * - Adicionar a baselayer inicial
   * - Registra os eventos de interação com o mapa
   */
		createMap: function createMap() {

			// Criando mapa
			this.mapa = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.map('mapa', {
				center: __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].center,
				zoom: __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].zoom,
				minZoom: this.selectedBaseMap.minZoom,
				maxZoom: this.selectedBaseMap.maxZoom,
				boxZoom: true,
				doubleClickZoom: false,
				zoomControl: false,
				contextmenu: true,
				contextmenuWidth: 140,
				preferCanvas: true,
				contextmenuItems: [{
					text: 'O que é?',
					callback: this.getInformacoesLayer
				}, {
					text: 'Inspecionar',
					callback: this.inspecionar
				}]
			});

			__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$mapa = this.mapa;

			this.boxZoom = new __WEBPACK_IMPORTED_MODULE_7__utils_customBoxZoom__["a" /* default */](this.mapa);

			// Adicionando mapa de fundo
			this.baseMapLayer = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.TileLayer(this.selectedBaseMap.url, {
				attribution: this.selectedBaseMap.attribution,
				tms: this.selectedBaseMap.tms,
				minZoom: this.selectedBaseMap.minZoom,
				maxZoom: this.selectedBaseMap.maxZoom
			});

			this.mapa.addLayer(this.baseMapLayer);

			__WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.control.scale({ imperial: false }).addTo(this.mapa);

			this.miniMapa = new __WEBPACK_IMPORTED_MODULE_8__utils_leaflet_minimap__["a" /* default */](this.mapa);

			this.registerEvents();

			this.adicionarFuncionalidadeDesenho();
		},


		/**
   * Busca as informações da layer que encontra-se mais ao topo
   */
		getInformacoesLayer: function getInformacoesLayer(e) {

			this.$bus.$emit('informacoesPonto.show', { latlng: e.latlng });
		},


		/**
   * Busca as informações de todas as layers ativas
   */
		inspecionar: function inspecionar(e) {
			this.$bus.$emit('inspecao.show', { latlng: e.latlng, inspecionar: true });
		},


		/**
   * Registra todos os eventos de responsabilidade do mapa
   */
		registerEvents: function registerEvents() {
			var _this = this;

			this.$bus.$on('mapa.zoomIn', function () {
				return _this.mapa.zoomIn();
			});
			this.$bus.$on('mapa.zoomOut', function () {
				return _this.mapa.zoomOut();
			});
			this.$bus.$on('mapa.initialZoom', function () {
				return _this.mapa.setView(__WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].center, __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].zoom);
			});
			this.$bus.$on('mapa.boxZoom', function () {
				return _this.boxZoom.enable();
			});
			this.$bus.$on('mapa.changeZoom', function (z) {
				return _this.mapa.setZoom(z);
			});

			this.$bus.$on('mapa.changeBaseMap', this.changeBaseMap);

			this.$bus.$on('mapa.addCoordinatePoint', this.addCoordinatePoint);
			this.$bus.$on('mapa.removeCoordinatePoint', this.removeCoordinateMarker);

			this.mapa.on('zoomend', function () {
				return _this.setMapZoom(_this.mapa.getZoom());
			});
			this.mapa.on('mousemove', function (e) {
				return _this.setCoordinate(e.latlng);
			});
			this.mapa.on('click', function () {
				return _this.removeCoordinateMarker(null, true);
			});
			this.mapa.on('dblclick', function (e) {
				return _this.onDoubleClick(e);
			});
			this.mapa.on('moveend', function () {
				return _this.atualizarMarcadores();
			});
			this.mapa.on('contextmenu', function (e) {
				return _this.onContextMenu(e);
			});

			this.$bus.$on('mapa.draw', this.startDraw);
			this.$bus.$on('mapa.cancelDraw', this.cancelDraw);
			this.$bus.$on('mapa.removeLayer', this.removeLayer);
			this.$bus.$on('mapa.addLayer', this.addLayer);
			this.$bus.$on('mapa.centerLayer', this.centerLayer);

			this.$bus.$on('mapa.centerCamada', this.centerCamada);
		},


		/**
   * Processa o double click no mapa mapa evitar a execução da busca de informações
   * do ponto caso estiver vetorizando uma geometria.
   */
		onDoubleClick: function onDoubleClick(e) {

			if (this.isDrawToolEnable()) {

				var drawTool = this.getEnabledDrawTool();

				if (drawTool._finishShape) drawTool._finishShape();
			} else {

				this.getInformacoesLayer(e);
			}
		},


		/**
   * Processa o click do botão direito no mapa mapa evitar a exibição do context menu
   * caso estiver vetorizando uma geometria
   */
		onContextMenu: function onContextMenu(e) {

			if (this.isDrawToolEnable()) this.mapa.contextmenu.hide();
		},


		/**
   * Adiciona a funcionalidade de base de referência caso esteja configurada
   */
		adicionarFuncionalidadeDesenho: function adicionarFuncionalidadeDesenho() {
			var _this2 = this;

			var drawingStyle = { dashArray: '10,10', color: __WEBPACK_IMPORTED_MODULE_15__utils_drawUtils__["a" /* default */].DEFAULT_COLOR, weight: 2 };

			this.draw.tools[__WEBPACK_IMPORTED_MODULE_15__utils_drawUtils__["a" /* default */].POLYGON_TOOL] = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.Draw.Polygon(this.mapa, {
				icon: new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.DivIcon({
					className: 'leaflet-div-icon leaflet-editing-icon leaflet-editing-icon-polygon'
				}),

				shapeOptions: drawingStyle
			});

			this.draw.tools[__WEBPACK_IMPORTED_MODULE_15__utils_drawUtils__["a" /* default */].RECTANGLE_TOOL] = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.Draw.Rectangle(this.mapa, { shapeOptions: drawingStyle });

			this.draw.tools[__WEBPACK_IMPORTED_MODULE_15__utils_drawUtils__["a" /* default */].POLYLINE_TOOL] = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.Draw.Polyline(this.mapa, { shapeOptions: drawingStyle });

			this.draw.tools[__WEBPACK_IMPORTED_MODULE_15__utils_drawUtils__["a" /* default */].CIRCLEMARKER_TOOL] = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.Draw.CircleMarker(this.mapa, { shapeOptions: drawingStyle });

			this.mapa.on('draw:created', function (e) {
				return _this2.onDrawCreated(e);
			});
			this.mapa.on('draw:canceled', function (e) {
				return _this2.onDrawCanceled(e);
			});
		},


		/**
   * Adiciona a geometria após finalização do desenho
   */
		onDrawCreated: function onDrawCreated(e) {

			this.mapa.addLayer(e.layer);

			if (this.draw.options.center) this.centerLayer(e.layer);

			if (this.draw.options.onComplete) this.draw.options.onComplete(e.layer);
		},


		/**
   * Trata cancelamento da vetorização (tecla ESC)
   */
		onDrawCanceled: function onDrawCanceled(e) {

			if (this.draw.options.onCancel) this.draw.options.onCancel();

			this.draw.options = null;
		},


		/*
   * Método que ativa/desativa a ferramenta de desenho da base de referência
   */
		startDraw: function startDraw(options) {

			if (this.isDrawToolEnable()) this.cancelDraw();

			options.tool = options.tool || 'polygon';
			var tool = this.draw.tools[options.tool];

			if (!tool) {
				console.error('Não existe a ferramenta de desenho "' + options.tool + '"');
				return;
			}

			tool.enable();
			this.draw.options = options;
		},


		/**
   * Desabilita a ferramenta de desenho.
   */
		cancelDraw: function cancelDraw() {

			if (!this.isDrawToolEnable()) return;

			for (var toolName in this.draw.tools) {

				var tool = this.draw.tools[toolName];
				if (tool && tool._enabled) tool.disable();
			}

			this.mapa.fire('draw:canceled');
		},


		/**
   * Desabilita todas as ferramentas de desenho
   */
		disableDrawTools: function disableDrawTools() {

			for (var toolName in this.draw.tools) {

				var tool = this.draw.tools[toolName];
				if (tool && tool._enabled) tool.disable();
			}
		},


		/**
   * Centraliza o mapa na Layer que contém a geometria da base de referência
   */
		centerLayer: function centerLayer(layer) {

			this.mapa.fitBounds(layer.getBounds());
		},


		/**
   * Centraliza o mapa na camada
   */
		centerCamada: function centerCamada(camada) {

			if (!camada || !camada.id || !this.layers[camada.id]) return;

			var layer = this.layers[camada.id];
			layer = layer.geom || layer.marker;

			if (layer) this.mapa.fitBounds(layer.getBounds());
		},


		/**
   * Remove uma layer do mapa
   */
		removeLayer: function removeLayer(layer) {

			if (layer) this.mapa.removeLayer(layer);
		},


		/**
   * Adiciona uma layer ao mapa
   */
		addLayer: function addLayer(layer) {

			if (layer) this.mapa.addLayer(layer);
		},


		/**
   * Altera o mapa de fundo
   */
		changeBaseMap: function changeBaseMap(tileLayer) {

			this.mapa.removeLayer(this.baseMapLayer);

			this.baseMapLayer = new __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.TileLayer(tileLayer.url, {
				attribution: tileLayer.attribution,
				tms: tileLayer.tms,
				minZoom: tileLayer.minZoom,
				maxZoom: tileLayer.maxZoom
			});

			this.mapa.addLayer(this.baseMapLayer);

			// Faz com que a layer fica sempre em baixo das demais
			this.baseMapLayer.bringToBack();

			this.changeMaxZoom(tileLayer.maxZoom);
			this.changeMinZoom(tileLayer.minZoom);
		},


		/*
   * Altera o valor do máximo do zoom permitido pelo mapa e atualiza o vuex com o novo valor
   */
		changeMaxZoom: function changeMaxZoom(newMaxZoom) {

			var currentZoom = this.mapa.getZoom();

			if (currentZoom > newMaxZoom) this.mapa.setZoom(newMaxZoom);

			this.mapa.setMaxZoom(newMaxZoom);

			this.setMaxZoom(newMaxZoom);
		},


		/*
   * Altera o valor do mínimo do zoom permitido pelo mapa e atualiza o vuex com o novo valor
   */
		changeMinZoom: function changeMinZoom(newMinZoom) {

			var currentZoom = this.mapa.getZoom();

			if (currentZoom < newMinZoom) this.mapa.setZoom(newMinZoom);

			this.mapa.setMinZoom(newMinZoom);

			this.setMinZoom(newMinZoom);
		},


		/**
   * Adiciona coordenada no mapa
   */
		addCoordinatePoint: function addCoordinatePoint(options) {

			if (this.markers[options.markerCode]) {
				this.removeCoordinateMarker(options.markerCode);
			}

			var marker = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.marker([options.lat, options.lng], {
				icon: __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.BeautifyIcon.icon(options.markerStyle),
				draggable: false
			});

			marker.addTo(this.mapa);

			this.markers[options.markerCode] = {
				marker: marker,
				fixed: options.fixed
			};

			if (options.center) {
				var latlng = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.latLng(options.lat, options.lng);
				this.mapa.flyTo(latlng);
			}

			if (options.inspecionar) {
				this.inspecionar({
					latlng: { lat: options.lat, lng: options.lng }
				});
			}
		},


		/**
   * Remove o marcador da coordenada inserida no mapa
   */
		removeCoordinateMarker: function removeCoordinateMarker(code, onlyTempMarkers) {

			if (code) {

				if (this.markers[code]) {
					this.mapa.removeLayer(this.markers[code].marker);
					delete this.markers[code];
				}
			} else {

				for (var markerCode in this.markers) {

					var marker = this.markers[markerCode];

					if (!onlyTempMarkers || !marker.fixed) {
						this.mapa.removeLayer(marker.marker);
						delete this.markers[markerCode];
					}
				}
			}
		},


		/**
   * Atualiza as camadas do mapa de acordo com as camadas ativas.
   */
		atualizarCamadasAtivas: function atualizarCamadasAtivas() {

			var oldLayers = this.layers;
			this.layers = {};
			var novasCamadasMarcador = [];

			for (var i = 0; i < this.camadasAtivas.length; i++) {

				var camada = this.camadasAtivas[i];

				if (!oldLayers[camada.id]) {

					this.adicionarCamada(camada);

					if (camada.visualizacao.marcador) novasCamadasMarcador.push(camada.id);
				} else {

					this.layers[camada.id] = oldLayers[camada.id];
				}

				delete oldLayers[camada.id];
			}

			for (var prop in oldLayers) {
				this.removerCamada(oldLayers[prop]);
			}

			if (novasCamadasMarcador && novasCamadasMarcador.length) {
				this.buscarMarcadoresCamadas(novasCamadasMarcador);
			}

			this._reordenarCamadas();
		},
		_reordenarCamadas: function _reordenarCamadas() {

			for (var i = 0; i < this.camadasAtivas.length; i++) {

				var layer = this.layers[this.camadasAtivas[i].id];
				if (layer.geom) layer.geom.bringToFront();
			}
		},


		/**
   * Adiciona uma nova camada ao mapa.
   */
		adicionarCamada: function adicionarCamada(camada) {

			var layer = {};

			// Camada WMS
			if (camada.visualizacao.mapa) {

				if (camada.geoServer && camada.geoServer.layer) {

					layer.geom = this.criarCamadaWms(camada);
				} else if (camada.geoJson) {

					layer.geom = this.criarCamadaGeoJson(camada);
				}

				layer.geom.addTo(this.mapa);
			}

			if (camada.visualizacao.marcador) {

				layer.marker = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.layerGroup([]).addTo(this.mapa);
			}

			this.layers[camada.id] = layer;
			this.$bus.$emit('mapa.camadaAdicionada', camada);
		},


		/**
   * Cria uma nova layer do leaflet a partir de uma camada WMS
   */
		criarCamadaWms: function criarCamadaWms(camada) {

			var layer = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.tileLayer.wms(__WEBPACK_IMPORTED_MODULE_10__services_camadasService__["a" /* default */].WMS_URL, {
				layers: camada.geoServer.layer,
				transparent: true,
				format: 'image/png',
				uppercase: true
			});

			return layer;
		},


		/**
   * Cria uma nova layer do leaflet a partir de uma camada GeoJSON
   */
		criarCamadaGeoJson: function criarCamadaGeoJson(camada) {

			var style = __WEBPACK_IMPORTED_MODULE_14__models_estilo__["a" /* default */].toMapStyle(camada.estiloPadrao);
			return __WEBPACK_IMPORTED_MODULE_4__utils_leafletUtils__["a" /* default */].createGeoJsonLayer(camada.geoJson, style);
		},


		/**
   * Remove uma camada do mapa.
   */
		removerCamada: function removerCamada(layer) {

			if (layer.geom) this.mapa.removeLayer(layer.geom);

			if (layer.marker) this.mapa.removeLayer(layer.marker);
		},


		/* Métodos para gerenciar os marcadores das camadas */

		deveExibirMarcadores: function deveExibirMarcadores() {
			return this.mapa.getZoom() >= __WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].minZoomMarkers;
		},
		limparMarcadores: function limparMarcadores() {

			for (var id in this.layers) {

				var layer = this.layers[id];
				if (layer.marker) layer.marker.clearLayers();
			}
		},
		atualizarMarcadores: function atualizarMarcadores() {

			if (!this.deveExibirMarcadores()) {

				if (!this.layersMarkersActive) return;
				this.limparMarcadores();
				this.layersMarkersActive = false;
			} else {

				this.layersMarkersActive = true;
				this.buscarMarcadoresCamadas();
			}
		},
		buscarMarcadoresCamadas: function buscarMarcadoresCamadas(idsCamadas) {
			var _this3 = this;

			idsCamadas = idsCamadas || this.idsCamadasMarcador;

			if (!this.deveExibirMarcadores()) return;

			if (!idsCamadas || !idsCamadas.length) return;

			var wkt = __WEBPACK_IMPORTED_MODULE_4__utils_leafletUtils__["a" /* default */].boundsToWKT(this.mapa.getBounds());

			__WEBPACK_IMPORTED_MODULE_10__services_camadasService__["a" /* default */].findMarcadores(idsCamadas, wkt, function (data) {

				if (!data || !data.length) return;

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var grupo = _step.value;

						_this3.adicionarMarcadoresCamada(grupo);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			});
		},
		adicionarMarcadoresCamada: function adicionarMarcadoresCamada(marcadores) {

			if (!this.deveExibirMarcadores()) return;

			var layer = this.layers[marcadores.idCamada];

			if (!layer || !layer.marker) return;

			layer.marker.clearLayers();

			var estilos = _.keyBy(marcadores.estilos, 'id');
			var bus = this.$bus;

			var onMarkerClick = function onMarkerClick(e) {
				e.originalEvent.preventDefault();
				e.originalEvent.stopPropagation();
				bus.$emit('camada.exibirRegistro', { registro: e.target._registro });
			};

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(marcadores.registros), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var registro = _step2.value;


					var estilo = estilos[registro.idEstilo];
					var coords = registro.centroid.coordinates;

					var marker = __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.marker([coords[1], coords[0]], {
						icon: __WEBPACK_IMPORTED_MODULE_3_leaflet___default.a.BeautifyIcon.icon(__WEBPACK_IMPORTED_MODULE_13__utils_markerStyles__["a" /* default */].getMarcadorCamada(estilo)),
						draggable: false
					});

					marker._registro = registro;
					marker.addTo(layer.marker);
					marker.on('click', onMarkerClick);
					marker.on('dblclick', onMarkerClick);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		},
		getEnabledDrawTool: function getEnabledDrawTool() {

			for (var toolName in this.draw.tools) {

				var tool = this.draw.tools[toolName];
				if (tool && tool._enabled) return tool;
			}
		},
		isDrawToolEnable: function isDrawToolEnable() {

			return !!this.getEnabledDrawTool();
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["a" /* mapMutations */])(['setMinZoom', 'setMaxZoom', 'setMapZoom', 'setCoordinate', 'setBaseMap'])),

	mounted: function mounted() {

		if (!this.mapa) {
			this.createMap();
		}
	},
	created: function created() {
		var _this4 = this;

		// Busca o base layer default
		this.selectedBaseMap = _.find(__WEBPACK_IMPORTED_MODULE_9__config_js__["a" /* default */].baseMaps, function (baseMap) {

			if (baseMap.default) {
				_this4.setBaseMap(baseMap);
			}

			return baseMap.default === true;
		});
	},


	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
		idsCamadasMarcador: function idsCamadasMarcador() {

			if (!this.layers) return null;

			var ids = [];

			for (var id in this.layers) {

				if (this.layers[id].marker) ids.push(id);
			}

			return ids;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapState */])({
		mapZoom: function mapZoom(state) {
			return state.mapa.maxZoom;
		},
		camadasAtivas: function camadasAtivas(state) {
			return state.camadasAtivas || [];
		}
	})),

	watch: {
		camadasAtivas: function camadasAtivas() {
			this.atualizarCamadasAtivas();
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_camadasService__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_tipoAtributoCamada__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_EmptyResult__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_EmptyResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_utils_EmptyResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_Paginacao__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_Paginacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_utils_Paginacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListagemRegistrosCamada__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListagemRegistrosCamada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ListagemRegistrosCamada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utils_Alert__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utils_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_utils_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_VisualizacaoRegistroCamada__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_VisualizacaoRegistroCamada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_VisualizacaoRegistroCamada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_markerStyles__ = __webpack_require__(31);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















var PAGINA_INICIAL = 1;

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Pesquisa',

	components: { EmptyResult: __WEBPACK_IMPORTED_MODULE_4__components_utils_EmptyResult___default.a, ListagemRegistros: __WEBPACK_IMPORTED_MODULE_6__ListagemRegistrosCamada___default.a, Paginacao: __WEBPACK_IMPORTED_MODULE_5__components_utils_Paginacao___default.a, Alert: __WEBPACK_IMPORTED_MODULE_7__components_utils_Alert___default.a, VisualizacaoRegistroCamada: __WEBPACK_IMPORTED_MODULE_8__components_VisualizacaoRegistroCamada___default.a },

	componentOptions: {

		title: 'Pesquisa',

		actions: [[{
			name: 'Pesquisa',
			iconClass: 'mdi mdi-magnify',
			showView: true
		}]]
	},

	data: function data() {
		return {
			camada: null,
			atributo: null,
			atributos: [],
			requestOptions: {
				lockElement: '#pesquisaCamada',
				lockMessage: 'Aguarde, buscando atributos.'
			},
			tipoAtributo: __WEBPACK_IMPORTED_MODULE_3__models_tipoAtributoCamada__["a" /* default */],
			filtro: null,
			registrosPesquisa: null,
			pesquisaEfetuada: false,
			paginacao: {
				itens: []
			},
			paginationOptions: {
				offset: 1,
				previousText: '«',
				nextText: '»',
				alwaysShowPrevNext: true
			},
			registro: null,
			TipoAtributoCamada: __WEBPACK_IMPORTED_MODULE_3__models_tipoAtributoCamada__["a" /* default */]
		};
	},


	methods: {

		/**
   * Evento de onChange no select de Camadas
   */
		onCamadaChange: function onCamadaChange() {
			var _this = this;

			this.atributo = null;
			this.filtro = null;

			this.cleanValidation();

			__WEBPACK_IMPORTED_MODULE_2__services_camadasService__["a" /* default */].findAtributos(this.camada.id, this.requestOptions, function (result) {
				_this.atributos = result;
			});
		},


		/**
   * Evento de onChange no select de Atributos
   */
		onAtributoChange: function onAtributoChange() {

			this.filtro = null;
			this.cleanValidation();
		},


		/**
   * Limpa o errosBag do validation
   */
		cleanValidation: function cleanValidation() {
			var _this2 = this;

			setTimeout(function () {
				_this2.$validator.cleanErrors(['camada', 'atributo', 'filtro']);
			}, 100);
		},


		/**
   * Limpa os campos de filtros
   */
		clean: function clean() {

			this.camada = null;
			this.atributo = null;
			this.filtro = null;
			this.atributos = null;

			this.cleanValidation();
		},


		/**
   * Realiza a validação do formulário de filtro e chama o serviço de pesquisar
   */
		validateAndSearch: function validateAndSearch() {
			var _this3 = this;

			this.$validator.validateAll().then(function (result) {

				if (result) {

					if (_this3.$refs.paginacao) {
						_this3.$refs.paginacao.setPage(PAGINA_INICIAL);
					}

					_this3.search(PAGINA_INICIAL);
				}
			});
		},


		/**
   * Dispara o serviço de pesquisar no servidor
   */
		search: function search(page) {
			var _this4 = this;

			var params = {
				pagina: page,
				camada: this.camada.id,
				atributo: this.atributo.id,
				q: this.filtro
			};

			__WEBPACK_IMPORTED_MODULE_2__services_camadasService__["a" /* default */].pesquisar(params, this.requestOptions, function (data) {
				_this4.paginacao = data;
				_this4.registrosPesquisa = data.itens;
				_this4.pesquisaEfetuada = true;
			});
		},


		/**
   * Mostra os detalhes do resultado selecionado.
   */
		exibirRegistro: function exibirRegistro(e) {

			this.registro = e.registro;

			this.$bus.$emit('mapa.addCoordinatePoint', {
				markerCode: 'RegistroCamada',
				lat: this.registro.centroid.coordinates[1],
				lng: this.registro.centroid.coordinates[0],
				markerStyle: __WEBPACK_IMPORTED_MODULE_9__utils_markerStyles__["a" /* default */].registroCamada,
				center: true,
				fixed: true
			});
		},


		/**
   * Oculta o registro exibido, retornando à listagem.
   */
		ocultarRegistro: function ocultarRegistro(e) {

			this.$bus.$emit('mapa.removeCoordinatePoint', 'RegistroCamada');
			this.registro = null;
		},


		/**
   * Pesquisa a pesquisa através da navegação pela paginação
   */
		alterarPagina: function alterarPagina(page) {
			this.search(page);
		},


		/**
   * Método de destruição do component (executado quando ele não é mais visível)
   */
		beforeComponentHide: function beforeComponentHide() {

			if (this.$refs.listagemRegistros) {
				this.$refs.listagemRegistros.removerMarcador();
			}

			this.$bus.$emit('mapa.removeCoordinatePoint', 'RegistroCamada');
		},


		/**
   * Método de inicialização do component (executado quando ele se torna visível)
   */
		afterComponentShow: function afterComponentShow() {
			this.$emit('ocultarRegistro');
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])(['camadasOrdenadas']), {

		/**
   * Retorna qual validação deve ser utilizada pelo validator
   */
		validator: function validator() {

			var validator = 'required';

			if (!this.atributo) return validator;

			switch (this.atributo.tipo) {

				case this.tipoAtributo.TEXTO:
					validator = 'required';
					break;

				case this.tipoAtributo.DECIMAL:
					validator = 'required|decimal';
					break;

				case this.tipoAtributo.INTEIRO:
					validator = 'required|numeroInteiro';
					break;

				case this.tipoAtributo.DATA:
					validator = 'required|date_format:DD/MM/YYYY';
					break;
			}

			return validator;
		},
		camadasPesquisaveis: function camadasPesquisaveis() {

			return _.filter(this.camadasOrdenadas, function (camada) {
				return camada.possuiAtributosPublicos;
			});
		},
		pesquisaLiberada: function pesquisaLiberada() {

			return this.camadasPesquisaveis && this.camadasPesquisaveis.length > 0;
		}
	})

});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FloatBox__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FloatBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FloatBox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VisualizacaoRegistroCamada__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VisualizacaoRegistroCamada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__VisualizacaoRegistroCamada__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'SearchBox',
	extends: __WEBPACK_IMPORTED_MODULE_0__components_FloatBox___default.a,

	components: { VisualizacaoRegistroCamada: __WEBPACK_IMPORTED_MODULE_1__VisualizacaoRegistroCamada___default.a },

	data: function data() {
		return {
			expanded: false,
			viewComponents: [],
			currentComponent: null,
			registroVisivel: false,
			registro: null
		};
	},
	created: function created() {
		this.configureComponent(__WEBPACK_IMPORTED_MODULE_1__VisualizacaoRegistroCamada___default.a);
	},


	methods: {
		closeComponent: function closeComponent() {

			this.closeCurrentComponent();

			if (this.registroVisivel) {
				this.$bus.$emit('mapa.removeCoordinatePoint', 'RegistroCamada');
			}
		}
	}
});

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FloatBox__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_FloatBox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_FloatBox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'ToolBox',
	extends: __WEBPACK_IMPORTED_MODULE_0__components_FloatBox___default.a
});

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_camadasService__ = __webpack_require__(29);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'VisualizacaoRegistroCamada',

	componentOptions: {
		title: 'Visualização de registro',
		events: {
			'camada.exibirRegistro': 'init'
		}
	},

	props: {
		registro: Object,
		ignoreGlobalEvents: Boolean,
		showReturnButton: Boolean
	},

	data: function data() {
		return {
			registroPesquisado: null
		};
	},


	methods: {
		ocultarRegistro: function ocultarRegistro() {
			this.$emit('close');
		},
		onFindRegistroComplete: function onFindRegistroComplete(registro) {

			this.registroPesquisado = registro;
		},
		init: function init(options) {
			var _this = this;

			this.$emit('ocultarRegistro');
			this.registroPesquisado = null;

			var requestOptions = {
				lockElement: '#informacoesRegistro',
				lockMessage: 'Aguarde, buscando informações.'
			};

			__WEBPACK_IMPORTED_MODULE_0__services_camadasService__["a" /* default */].findRegistroById(options.registro.idCamada, options.registro.id, function (data) {

				_this.onFindRegistroComplete(data);
			}, null, requestOptions);
		}
	},

	computed: {
		camada: function camada() {
			return this.registroVisualizacao && this.$store.getters.getCamada(this.registroVisualizacao.idCamada);
		},
		urlMaisInformacoes: function urlMaisInformacoes() {
			return this.registroVisualizacao && __WEBPACK_IMPORTED_MODULE_0__services_camadasService__["a" /* default */].MAIS_INFORMACOES_URL.replace('{idCamada}', this.registroVisualizacao.idCamada).replace('{idRegistro}', this.registroVisualizacao.id);
		},
		registroVisualizacao: function registroVisualizacao() {

			return this.registroPesquisado || this.registro;
		}
	}
});

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Zoom',

	componentOptions: {
		actions: [[{
			name: 'Zoom in',
			iconClass: 'mdi mdi-plus',
			action: 'zoomIn'
		}, {
			name: 'Zoom out',
			iconClass: 'mdi mdi-minus',
			action: 'zoomOut'
		}], [{
			name: 'Zoom por seleção',
			iconClass: 'mdi mdi-shape-rectangle-plus',
			action: 'boxZoom'
		}], [{
			name: 'Zoom inicial',
			iconClass: 'mdi mdi-home',
			action: 'initialZoom'
		}]]
	},

	methods: {
		zoomIn: function zoomIn() {
			this.$bus.$emit('mapa.zoomIn');
		},
		zoomOut: function zoomOut() {
			this.$bus.$emit('mapa.zoomOut');
		},
		initialZoom: function initialZoom() {
			this.$bus.$emit('mapa.initialZoom');
		},
		boxZoom: function boxZoom() {
			this.$bus.$emit('mapa.boxZoom');
		}
	}
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'ZoomSelect',

	data: function data() {
		return {
			currentZoom: null,
			showOptions: false,
			selectedBaseMap: null
		};
	},


	methods: {
		updateZoom: function updateZoom(zoom) {

			this.$bus.$emit('mapa.changeZoom', zoom);
			this.showOptions = false;
		}
	},

	computed: {
		mapZoom: function mapZoom() {

			return this.$store.state.mapa.zoom;
		},
		minZoom: function minZoom() {

			return this.$store.state.mapa.minZoom;
		},
		maxZoom: function maxZoom() {

			return this.$store.state.mapa.maxZoom;
		}
	},

	mounted: function mounted() {
		var _this = this;

		this.currentZoom = this.mapZoom;

		this.selectedBaseMap = _.find(this.baseMaps, function (baseMap) {
			return baseMap.default;
		});

		this.$store.watch(this.$store.getters.mapaZoom, function (z) {
			_this.currentZoom = z;
		});
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_ColorPalette__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_ColorPalette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_utils_ColorPalette__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_InputErrors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_InputErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_utils_InputErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_DrawButton__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_DrawButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_utils_DrawButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_tipoGeometria__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_estilo__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_drawUtils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(11);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var COR_PADRAO = __WEBPACK_IMPORTED_MODULE_8__utils_drawUtils__["a" /* default */].DEFAULT_COLOR;
var COR_DESTAQUE = '#FF0000';

/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'AdicaoCamadaGeometria',

	components: { ColorPalette: __WEBPACK_IMPORTED_MODULE_3__components_utils_ColorPalette___default.a, InputErrors: __WEBPACK_IMPORTED_MODULE_4__components_utils_InputErrors___default.a, DrawButton: __WEBPACK_IMPORTED_MODULE_5__components_utils_DrawButton___default.a },

	props: {
		tipoGeometria: {
			tipe: Object,
			required: true
		}
	},

	data: function data() {
		return {
			geometrias: [],
			nome: '',
			style: null,
			styleDestaque: null,
			cor: null,
			validacaoExecutada: false,
			drawTool: __WEBPACK_IMPORTED_MODULE_8__utils_drawUtils__["a" /* default */].POLYGON_TOOL
		};
	},
	created: function created() {

		this.configureStyle();

		var estilo = __WEBPACK_IMPORTED_MODULE_7__models_estilo__["a" /* default */].criarEstiloCamadaUsuario(COR_DESTAQUE, this.tipoGeometria);
		this.styleDestaque = __WEBPACK_IMPORTED_MODULE_7__models_estilo__["a" /* default */].toMapStyle(estilo, true);

		if (this.tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_6__models_tipoGeometria__["a" /* default */].POLIGONO.codigo) {

			this.drawTool = __WEBPACK_IMPORTED_MODULE_8__utils_drawUtils__["a" /* default */].POLYGON_TOOL;
		} else if (this.tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_6__models_tipoGeometria__["a" /* default */].LINHA.codigo) {

			this.drawTool = __WEBPACK_IMPORTED_MODULE_8__utils_drawUtils__["a" /* default */].POLYLINE_TOOL;
		} else if (this.tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_6__models_tipoGeometria__["a" /* default */].PONTO.codigo) {

			this.drawTool = __WEBPACK_IMPORTED_MODULE_8__utils_drawUtils__["a" /* default */].CIRCLEMARKER_TOOL;
		}
	},


	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
		onGeometriaVetorizada: function onGeometriaVetorizada(data) {

			this.geometrias.push(data);
			data.layer.setStyle(this.style);
		},
		removerGeometria: function removerGeometria(index) {

			var geometria = this.geometrias[index];
			this.geometrias.splice(index, 1);
			this.$mapa.removeLayer(geometria.layer);
		},
		configureStyle: function configureStyle() {

			var cor = this.cor || COR_PADRAO;
			var estilo = __WEBPACK_IMPORTED_MODULE_7__models_estilo__["a" /* default */].criarEstiloCamadaUsuario(cor, this.tipoGeometria);
			this.style = __WEBPACK_IMPORTED_MODULE_7__models_estilo__["a" /* default */].toMapStyle(estilo, true);
		},
		onCorChange: function onCorChange() {

			this.configureStyle();

			if (!this.geometrias || this.geometrias.length === 0) return;

			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.geometrias), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var geometria = _step.value;


					geometria.layer.setStyle(this.style);
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		},
		onGeometriaMouseEnter: function onGeometriaMouseEnter(index) {

			this.geometrias[index].layer.setStyle(this.styleDestaque);
		},
		onGeometriaMouseLeave: function onGeometriaMouseLeave(index) {

			this.geometrias[index].layer.setStyle(this.style);
		},
		removerGeometriasMapa: function removerGeometriasMapa() {

			if (!this.geometrias || !this.geometrias.length) return;

			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.geometrias), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var geometria = _step2.value;

					this.$mapa.removeLayer(geometria.layer);
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}
		},
		adicionarGeometriasMapa: function adicionarGeometriasMapa() {

			if (!this.geometrias || !this.geometrias.length) return;

			var _iteratorNormalCompletion3 = true;
			var _didIteratorError3 = false;
			var _iteratorError3 = undefined;

			try {
				for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.geometrias), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
					var geometria = _step3.value;

					this.$mapa.addLayer(geometria.layer);
				}
			} catch (err) {
				_didIteratorError3 = true;
				_iteratorError3 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion3 && _iterator3.return) {
						_iterator3.return();
					}
				} finally {
					if (_didIteratorError3) {
						throw _iteratorError3;
					}
				}
			}
		},
		limparCampos: function limparCampos() {
			var _this = this;

			this.cor = null;
			this.nome = null;
			this.removerGeometriasMapa();
			this.geometrias = [];
			this.configureStyle();

			this.$nextTick().then(function () {
				_this.validacaoExecutada = false;
				_this.$validator.cleanErrors();
			});
		},
		cancelar: function cancelar() {

			this.limparCampos();
			this.$emit('limpar');
		},
		adicionarCamada: function adicionarCamada() {
			var _this2 = this;

			this.$emit('limpar');

			this.validacaoExecutada = true;

			if (!this.geometrias || this.geometrias.length === 0) {

				this.$validator.validateAll();
				return;
			}

			this.$validator.validateAll().then(function (result) {

				var layers = _.map(_this2.geometrias, 'layer');
				var layerGroup = __WEBPACK_IMPORTED_MODULE_2_leaflet___default.a.layerGroup(layers);

				if (result) {

					_this2.$emit('adicionarCamada', {
						nome: _this2.nome,
						geoJson: layerGroup.toGeoJSON(),
						cor: _this2.cor
					});

					_this2.limparCampos();
				}
			});
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapMutations */])(['adicionarCamadaUsuario', 'ativarCamada']))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_leafletUtils__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_ShapeInput__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_ShapeInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils_ShapeInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_ColorPalette__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_utils_ColorPalette___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_utils_ColorPalette__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_InputErrors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_utils_InputErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_utils_InputErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_estilo__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_tipoGeometria__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_drawUtils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'AdicaoCamadaShape',

	components: { ShapeInput: __WEBPACK_IMPORTED_MODULE_2__components_utils_ShapeInput___default.a, ColorPalette: __WEBPACK_IMPORTED_MODULE_3__components_utils_ColorPalette___default.a, InputErrors: __WEBPACK_IMPORTED_MODULE_4__components_utils_InputErrors___default.a },

	data: function data() {
		return {
			geoJsonShape: null,
			nome: '',
			cor: null,
			layer: null,
			style: null,
			tipoGeometria: __WEBPACK_IMPORTED_MODULE_6__models_tipoGeometria__["a" /* default */].POLIGONO
		};
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		limparCampos: function limparCampos() {
			var _this = this;

			this.removerGeometriasMapa();
			this.cor = null;
			this.nome = null;
			this.geoJsonShape = null;
			this.layer = null;
			this.tipoGeometria = __WEBPACK_IMPORTED_MODULE_6__models_tipoGeometria__["a" /* default */].POLIGONO;
			this.$refs.shapeInput.clear();
			this.configureStyle();

			this.$nextTick().then(function () {
				_this.$validator.cleanErrors();
			});
		},
		cancelar: function cancelar() {
			this.limparCampos();
			this.$emit('limpar');
		},
		adicionarCamadaShape: function adicionarCamadaShape() {
			var _this2 = this;

			this.$emit('limpar');

			this.$validator.validateAll().then(function (result) {

				if (result) {

					_this2.$emit('adicionarCamada', {
						nome: _this2.nome,
						geoJson: _this2.geoJsonShape,
						cor: _this2.cor
					});

					_this2.limparCampos();
				}
			});
		},
		onCorChange: function onCorChange() {

			if (this.layer) {

				this.configureStyle();
				this.layer.setStyle(this.style);
			}
		},
		configureStyle: function configureStyle() {

			var cor = this.cor || __WEBPACK_IMPORTED_MODULE_7__utils_drawUtils__["a" /* default */].DEFAULT_COLOR;
			var estilo = __WEBPACK_IMPORTED_MODULE_5__models_estilo__["a" /* default */].criarEstiloCamadaUsuario(cor, this.tipoGeometria);
			this.style = __WEBPACK_IMPORTED_MODULE_5__models_estilo__["a" /* default */].toMapStyle(estilo, true);
		},
		removerGeometriasMapa: function removerGeometriasMapa() {

			if (this.layer) this.$bus.$emit('mapa.removeLayer', this.layer);
		},
		adicionarGeometriasMapa: function adicionarGeometriasMapa() {

			if (this.layer) this.$bus.$emit('mapa.addLayer', this.layer);
		},
		onShapeChange: function onShapeChange(geoJson) {

			this.removerGeometriasMapa();

			this.tipoGeometria = __WEBPACK_IMPORTED_MODULE_6__models_tipoGeometria__["a" /* default */].getFromGeoJson(geoJson);
			this.configureStyle();

			this.layer = __WEBPACK_IMPORTED_MODULE_1__utils_leafletUtils__["a" /* default */].createGeoJsonLayer(geoJson, this.style);

			this.layer.addTo(this.$mapa);
			this.$bus.$emit('mapa.centerLayer', this.layer);
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* mapMutations */])(['adicionarCamadaUsuario', 'ativarCamada']))
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_Alert__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdicaoCamadaShape__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AdicaoCamadaShape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AdicaoCamadaShape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdicaoCamadaGeometria__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AdicaoCamadaGeometria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AdicaoCamadaGeometria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_tipoGeometria__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_estilo__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(11);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'AdicaoCamadas',

	componentOptions: {

		title: 'Nova Camada',

		actions: [[{
			name: 'Adicionar nova camada',
			iconClass: 'mdi mdi-lead-pencil',
			showView: true
		}]]
	},

	components: { Alert: __WEBPACK_IMPORTED_MODULE_1__components_utils_Alert___default.a, AdicaoCamadaShape: __WEBPACK_IMPORTED_MODULE_2__AdicaoCamadaShape___default.a, AdicaoCamadaGeometria: __WEBPACK_IMPORTED_MODULE_3__AdicaoCamadaGeometria___default.a },

	data: function data() {
		return {
			tela: 'SHAPE',
			geoJsonShape: null,
			showSuccess: false,
			ultimaCamadaAdicionada: null,
			TipoGeometria: __WEBPACK_IMPORTED_MODULE_4__models_tipoGeometria__["a" /* default */]
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.$bus.$on('mapa.camadaAdicionada', function (camada) {

			if (_this.ultimaCamadaAdicionada && (camada === _this.ultimaCamadaAdicionada || camada.id === _this.ultimaCamadaAdicionada.id)) {

				_this.ultimaCamadaAdicionada = null;
			}
		});
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		abrirTela: function abrirTela(tela) {

			if (tela === this.tela) return;

			this.hideSuccess();

			var componenteAtual = this.$refs[this.tela];
			var componenteNovo = this.$refs[tela];

			if (componenteAtual.removerGeometriasMapa) componenteAtual.removerGeometriasMapa();

			if (componenteNovo.adicionarGeometriasMapa) componenteNovo.adicionarGeometriasMapa();

			this.tela = tela;
		},
		hideSuccess: function hideSuccess() {

			this.showSuccess = false;
		},
		getComponenteTelaAtiva: function getComponenteTelaAtiva() {

			if (!this.tela) return null;

			return this.$refs[this.tela];
		},
		adicionarCamada: function adicionarCamada(options) {

			var camada = this.criarCamada(options);
			this.ultimaCamadaAdicionada = camada;
			this.adicionarCamadaUsuario(camada);
			this.ativarCamada(camada);

			this.showSuccess = true;
		},
		criarCamada: function criarCamada(options) {

			var tipoGeometria = __WEBPACK_IMPORTED_MODULE_4__models_tipoGeometria__["a" /* default */].getFromGeoJson(options.geoJson);

			var estilo = __WEBPACK_IMPORTED_MODULE_5__models_estilo__["a" /* default */].criarEstiloCamadaUsuario(options.cor, tipoGeometria);
			estilo.padrao = true;

			return {
				nome: options.nome,
				geoJson: options.geoJson,
				visualizacao: {
					mapa: true,
					marcador: false
				},
				estiloPadrao: estilo,
				tipoGeometria: tipoGeometria
			};
		},


		// Método chamado pelo componente pai (ToolBox)
		beforeComponentHide: function beforeComponentHide() {

			this.$bus.$emit('mapa.cancelDraw');

			var componente = this.getComponenteTelaAtiva();

			if (componente && componente.removerGeometriasMapa) {

				componente.removerGeometriasMapa();
			}
		},


		// Método chamado pelo componente pai (ToolBox)
		afterComponentShow: function afterComponentShow() {

			var componente = this.getComponenteTelaAtiva();

			if (componente && componente.adicionarGeometriasMapa) {

				componente.adicionarGeometriasMapa();
			}
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapMutations */])(['adicionarCamadaUsuario', 'ativarCamada']))
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconeLegenda__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconeLegenda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__IconeLegenda__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Camadas',

	components: { IconeLegenda: __WEBPACK_IMPORTED_MODULE_0__IconeLegenda___default.a },

	props: {
		camada: Object
	},

	data: function data() {
		return {};
	},


	methods: {
		removerCamada: function removerCamada(camada) {

			this.$emit('remove');
		}
	}
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($, _) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CamadasTree__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CamadasTree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CamadasTree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CamadaAtiva__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CamadaAtiva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CamadaAtiva__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconeLegenda__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconeLegenda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__IconeLegenda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_stringUtils__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utils_EmptyResult__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utils_EmptyResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_utils_EmptyResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Camadas',

	components: { CamadasTree: __WEBPACK_IMPORTED_MODULE_2__CamadasTree___default.a, IconeLegenda: __WEBPACK_IMPORTED_MODULE_4__IconeLegenda___default.a, EmptyResult: __WEBPACK_IMPORTED_MODULE_7__components_utils_EmptyResult___default.a, Draggable: __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a, CamadaAtiva: __WEBPACK_IMPORTED_MODULE_3__CamadaAtiva___default.a },

	componentOptions: {

		title: 'Camadas',

		actions: [[{
			name: 'Camadas',
			iconClass: 'mdi mdi-layers',
			showView: true
		}]]
	},

	data: function data() {
		return {
			ESTRUTURA: 0,
			ATIVAS: 1,
			tela: 0,
			filtro: ''
		};
	},


	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
		setTela: function setTela(tela) {
			this.tela = tela;
		},
		setFocusFiltro: function setFocusFiltro() {
			$('#camadas-filter').focus();
		},
		limparFiltro: function limparFiltro() {
			this.filtro = '';
		},
		removerCamada: function removerCamada(camada) {

			this.desativarCamada(camada);
		},
		filtrarCamadas: function filtrarCamadas(camadas, filtro) {

			var filtroTrim = filtro && filtro.trim();

			if (!filtroTrim) {

				this.filtro = filtroTrim;
				return null;
			}

			var filtroLatinized = __WEBPACK_IMPORTED_MODULE_6__utils_stringUtils__["a" /* default */].latinize(filtroTrim).toLowerCase();

			camadas = _.filter(camadas, function (c) {

				return __WEBPACK_IMPORTED_MODULE_6__utils_stringUtils__["a" /* default */].latinize(c.nome).toLowerCase().indexOf(filtroLatinized) >= 0;
			});

			return camadas;
		},
		onCamadaMoved: function onCamadaMoved(evt) {

			var newIndex = this.camadasAtivas.length - evt.moved.newIndex - 1;
			this.moverCamadaAtiva({ camada: evt.moved.element, index: newIndex });
		},
		expandAll: function expandAll() {
			this.$refs.camadasTree.expandAll();
		},
		collapseAll: function collapseAll() {
			this.$refs.camadasTree.collapseAll();
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(['ativarCamada', 'desativarCamada', 'moverCamadaAtiva'])),

	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
		camadasAtivas: function camadasAtivas() {
			var camadas = this.$store.state.camadasAtivas && this.$store.state.camadasAtivas.slice().reverse();

			if (!camadas) return camadas;

			if (this.filtro && this.filtro.trim()) {

				return this.filtrarCamadas(camadas, this.filtro);
			} else {

				return camadas;
			}
		},
		possuiCamadasUsuario: function possuiCamadasUsuario() {
			var camadas = this.$store.state.camadasAtivas;

			if (camadas) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {

					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(camadas), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var c = _step.value;

						if (c.camadaUsuario) return true;
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}

			return false;
		},
		camadasFiltradas: function camadasFiltradas() {

			var camadas = this.filtrarCamadas(this.$store.state.camadasOrdenadas, this.filtro);

			return camadas ? { camadas: camadas } : {};
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapState */])(['estruturaCamadas'])),

	watch: {
		camadasAtivas: function camadasAtivas() {

			if (this.$refs.camadasTree) {
				this.$refs.camadasTree.refresh();
			}
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21), __webpack_require__(10)))

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(11);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'CamadasTree',

	props: {
		model: Object,
		grupoPai: Object,
		emitter: Object,
		first: Boolean,
		last: Boolean,
		level: {
			type: Number,
			default: 0
		},
		indents: Array
	},

	data: function data() {

		return {
			open: this.level === 0
		};
	},


	computed: {
		isGrupo: function isGrupo() {
			return !this.model.geoServer && !this.model.tipoGeometria;
		},
		eventEmitter: function eventEmitter() {
			return this.emitter || this;
		},
		childIndents: function childIndents() {
			if (this.level <= 1) return null;
			return this.indents ? _.concat(this.indents, !this.last) : [!this.last];
		},
		hasChildren: function hasChildren() {
			return this.isGrupo && (this.model.grupos && this.model.grupos.length > 0 || this.model.camadas && this.model.camadas.length > 0);
		}
	},

	mounted: function mounted() {
		if (!this.isGrupo && this.model.habilitado) {
			this.$emit('open');
		}
	},


	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
		onOpen: function onOpen() {
			this.open = true;
			this.$emit('open');
		},
		onClick: function onClick() {

			if (this.isGrupo) {
				this.open = !this.open;
			}
		},
		onCamadaCheck: function onCamadaCheck() {

			if (!this.model.habilitado) {
				this.ativarCamada(this.model);
			} else {
				this.desativarCamada(this.model);
			}
		},
		getEvent: function getEvent(name) {

			return this.isGrupo ? name + 'Grupo' : name + 'Camada';
		},
		callRecursive: function callRecursive(callback) {

			if (this.$children) {
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {

					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.$children), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var child = _step.value;


						if (child && child.$options && child.$options.name === 'CamadasTree') {
							child.callRecursive(callback);
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}

			callback(this);
		},
		refresh: function refresh() {

			this.callRecursive(function (node) {

				node.$forceUpdate();
			});
		},
		expandAll: function expandAll() {

			this.callRecursive(function (node) {

				if (node.level > 0) {
					node.open = true;
				}
			});
		},
		collapseAll: function collapseAll() {

			this.callRecursive(function (node) {

				if (node.level > 0) {
					node.open = false;
				}
			});
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapMutations */])(['ativarCamada', 'desativarCamada']))
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'IconeLegenda',

	props: {
		estilo: Object,
		camada: Object,
		estilosPersonalizados: Array
	},

	methods: {
		hexToRgba: function hexToRgba(hex, opacity) {

			var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

			if (!rgb) return 'rgba(0,0,0,0)';

			return 'rgba(' + parseInt(rgb[1], 16) + ',' + parseInt(rgb[2], 16) + ',' + parseInt(rgb[3], 16) + ',' + opacity + ')';
		},
		getCssEstilo: function getCssEstilo(estilo) {
			var contorno = estilo.contorno;
			var preenchimento = estilo.preenchimento;

			var style = {
				'border-width': contorno ? '1px' : '0',
				'border-color': contorno && this.hexToRgba(contorno.cor, contorno.opacidade),
				'background-color': preenchimento && this.hexToRgba(preenchimento.cor, preenchimento.opacidade) || 'rgba(0, 0, 0, 0)'
			};

			return style;
		}
	},

	computed: {
		isMultiEstilos: function isMultiEstilos() {
			return this.estilosPersonalizados && this.estilosPersonalizados.length > 0;
		},
		styles: function styles() {
			return !this.isMultiEstilos && this.getCssEstilo(this.estilo);
		},
		tipoGeometria: function tipoGeometria() {
			return this.camada.tipoGeometria;
		},
		possuiMarcador: function possuiMarcador() {

			if (this.isMultiEstilos) return this.camada.visualizacao.marcador;

			return !!this.estilo.marcador;
		},
		possuiMapa: function possuiMapa() {

			if (this.isMultiEstilos) return this.camada.visualizacao.mapa;

			return this.estilo.contorno || this.estilo.preenchimento;
		}
	}
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_Alert__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_camadasService__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListagemRegistrosCamada__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ListagemRegistrosCamada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ListagemRegistrosCamada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VisualizacaoRegistroCamada__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VisualizacaoRegistroCamada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_VisualizacaoRegistroCamada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_Paginacao__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_utils_Paginacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_utils_Paginacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_markerStyles__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var requestOptions = {
	lockElement: '#informacoesPonto',
	lockMessage: 'Aguarde, buscando informações.'
};

var PAGINA_INICIAL = 1;

/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'InformacoesPonto',

	componentOptions: {

		title: 'Informacoes do Ponto',

		events: {
			'informacoesPonto.show': 'buscarInformacoesPonto'
		}
	},

	components: { EmptyResult: __WEBPACK_IMPORTED_MODULE_0__components_utils_EmptyResult___default.a, Alert: __WEBPACK_IMPORTED_MODULE_1__components_utils_Alert___default.a, Paginacao: __WEBPACK_IMPORTED_MODULE_5__components_utils_Paginacao___default.a, ListagemRegistros: __WEBPACK_IMPORTED_MODULE_3__components_ListagemRegistrosCamada___default.a, VisualizacaoRegistroCamada: __WEBPACK_IMPORTED_MODULE_4__components_VisualizacaoRegistroCamada___default.a },

	data: function data() {
		return {
			wkt: null,
			msgEmptyResult: null,
			mensagemErro: '',
			pesquisaEfetuada: false,
			showAlert: false,
			registro: null,
			paginacaoRegistros: {
				itens: []
			},
			paginationOptions: {
				offset: 1,
				previousText: '«',
				nextText: '»',
				alwaysShowPrevNext: true
			}
		};
	},


	methods: {
		buscarInformacoesPonto: function buscarInformacoesPonto(e) {

			if (!e || !e.latlng) return;

			this.wkt = 'POINT (' + e.latlng.lng + ' ' + e.latlng.lat + ')';

			this.adicionarMarcador(e.latlng);

			this.buscarInformacoesWktCamada();
		},


		/**
   * Busca os registros de uma camada (grupo) selecionada na listagem de grupos.
   */
		buscarInformacoesWktCamada: function buscarInformacoesWktCamada(paginaAtual) {
			var _this = this;

			this.showAlert = false;

			if (!this.camadasAtivas || !this.camadasAtivas.length) {

				this.pesquisaEfetuada = false;
				return;
			}

			var idsCamadas = [this.camadasAtivas[this.camadasAtivas.length - 1].id];

			var params = {
				wkt: this.wkt,
				idsCamadas: idsCamadas,
				pagina: paginaAtual || PAGINA_INICIAL
			};

			__WEBPACK_IMPORTED_MODULE_2__services_camadasService__["a" /* default */].findInformacoesByWKT(params, function (result) {

				_this.pesquisaEfetuada = true;
				_this.paginacaoRegistros = result.data;

				if (_this.paginacaoRegistros && _this.paginacaoRegistros.itens && _this.paginacaoRegistros.itens.length === 1) {

					_this.exibirRegistro({ registro: _this.paginacaoRegistros.itens[0] });
				} else {

					_this.ocultarRegistro();
				}
			}, this.getRequestErrorHandler(), requestOptions);
		},
		adicionarMarcador: function adicionarMarcador(latlng) {

			this.$bus.$emit('mapa.addCoordinatePoint', {
				markerCode: 'InformacoesPonto',
				lat: latlng.lat,
				lng: latlng.lng,
				markerStyle: __WEBPACK_IMPORTED_MODULE_6__utils_markerStyles__["a" /* default */].inspecao,
				center: false,
				fixed: true
			});
		},
		removerMarcador: function removerMarcador() {

			this.$bus.$emit('mapa.removeCoordinatePoint', 'InformacoesPonto');
		},


		/**
   * Limpa todas as ferramentas de inspeção.
   */
		limpar: function limpar() {

			this.ocultarRegistro();

			if (this.$refs.listagemRegistros) this.$refs.listagemRegistros.limpar();

			if (this.$refs.paginacaoRegistros) this.$refs.paginacaoRegistros.setPage(PAGINA_INICIAL);

			this.paginacaoRegistros = null;
		},


		/**
   * Método utilizado na paginação de registros de camada para abrir uma pãgina.
   */
		alterarPaginaRegistros: function alterarPaginaRegistros(pagina) {

			this.buscarInformacoesWktCamada(pagina);
		},


		/**
   * Exibe os detalhes de um registro.
   */
		exibirRegistro: function exibirRegistro(e) {

			this.registro = e.registro;
		},


		/**
   * Oculta o registro exibido, retornando à listagem de registros de uma camada.
   */
		ocultarRegistro: function ocultarRegistro() {

			this.registro = null;
		},


		/**
   * Retorna uma função para tratar os erros de requisição.
   */
		getRequestErrorHandler: function getRequestErrorHandler() {
			var _this2 = this;

			return function (result) {
				_this2.limpar();
				_this2.ocultarRegistro();
				_this2.mensagemErro = result.texto || 'Não foi possível efetuar a pesquisa.';
				_this2.showAlert = true;
			};
		},


		// Método chamado pelo componente pai (SearchBox)
		beforeComponentHide: function beforeComponentHide() {

			this.limpar();
			this.removerMarcador();
		}
	},

	computed: {
		camadasAtivas: function camadasAtivas() {
			return this.$store.getters.camadasAtivasSig;
		}
	}
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(_) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_EmptyResult__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_EmptyResult___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils_EmptyResult__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_Alert__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InspecaoGeometria__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__InspecaoGeometria___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__InspecaoGeometria__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InspecaoShape__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InspecaoShape___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__InspecaoShape__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_tipoGeometria__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_leafletUtils__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_camadasService__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ListagemRegistrosCamada__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ListagemRegistrosCamada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_ListagemRegistrosCamada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ListagemGruposRegistrosCamadas__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_ListagemGruposRegistrosCamadas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_ListagemGruposRegistrosCamadas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_VisualizacaoRegistroCamada__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_VisualizacaoRegistroCamada___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_VisualizacaoRegistroCamada__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_utils_Paginacao__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_utils_Paginacao___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_utils_Paginacao__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__config_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_file_saver__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_file_saver__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















var requestOptions = {
	lockElement: '#inspecao',
	lockMessage: 'Aguarde, buscando informações.'
};

var requestOptionsCSV = {
	lockElement: '#inspecao',
	lockMessage: 'Aguarde, gerando arquivo CSV.'
};

var PAGINA_INICIAL = 1;

/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'Inspecao',

	componentOptions: {

		title: 'Inspeção',

		actions: [[{
			name: 'Inspeção',
			iconClass: 'mdi mdi-information-outline',
			showView: true
		}]],

		events: {
			'inspecao.show': 'inspecionarPonto'
		}
	},

	components: { EmptyResult: __WEBPACK_IMPORTED_MODULE_1__components_utils_EmptyResult___default.a, Alert: __WEBPACK_IMPORTED_MODULE_2__components_utils_Alert___default.a, InspecaoGeometria: __WEBPACK_IMPORTED_MODULE_3__InspecaoGeometria___default.a, InspecaoShape: __WEBPACK_IMPORTED_MODULE_4__InspecaoShape___default.a, Paginacao: __WEBPACK_IMPORTED_MODULE_11__components_utils_Paginacao___default.a, ListagemRegistros: __WEBPACK_IMPORTED_MODULE_8__components_ListagemRegistrosCamada___default.a, ListagemGruposRegistros: __WEBPACK_IMPORTED_MODULE_9__components_ListagemGruposRegistrosCamadas___default.a, VisualizacaoRegistroCamada: __WEBPACK_IMPORTED_MODULE_10__components_VisualizacaoRegistroCamada___default.a },

	data: function data() {
		return {
			tela: 'PONTO',
			telas: ['SHAPE', 'POLIGONO', 'PONTO'],
			TipoGeometria: __WEBPACK_IMPORTED_MODULE_5__models_tipoGeometria__["a" /* default */],
			geometria: null,
			layer: null,
			wktExpiration: null,
			maxAreaHA: __WEBPACK_IMPORTED_MODULE_12__config_js__["a" /* default */].inspecao.areaLimiteHA,

			wkt: null,
			wktKey: null,
			msgEmptyResult: null,
			mensagemErro: null,
			pesquisaEfetuada: false,
			showAlert: false,
			gruposInformacao: null,
			grupo: null,
			registro: null,
			paginacaoRegistros: {
				itens: []
			},
			paginationOptions: {
				offset: 1,
				previousText: '«',
				nextText: '»',
				alwaysShowPrevNext: true
			}
		};
	},


	methods: {

		/**
   * Alterna entre as ferramentas de inspeção.
   */
		abrirTela: function abrirTela(tela) {

			if (this.tela === tela) return;

			var componenteAtual = this.$refs[this.tela];
			var componenteNovo = this.$refs[tela];

			if (componenteAtual.removerGeometriasMapa) componenteAtual.removerGeometriasMapa();

			if (componenteNovo.adicionarGeometriasMapa) componenteNovo.adicionarGeometriasMapa();

			this.tela = tela;
		},


		/**
   * Executa as validações do componente de inspeção selecionado e busca os grupos
   * de informações.
   */
		inspecionar: function inspecionar() {
			var _this = this;

			this.showAlert = false;
			this.ocultarRegistro();
			this.ocultarGrupo();
			var tela = this.getTelaAtual();
			var geometria = tela.getGeometria();
			var layer = geometria && geometria.layer;

			this.geometria = tela.getGeometria();

			tela.validar(function () {

				if (layer !== _this.layer) {

					_this.geometria = geometria;
					_this.layer = layer;
					_this.wkt = __WEBPACK_IMPORTED_MODULE_6__utils_leafletUtils__["a" /* default */].layerToWKT(_this.layer);
					_this.wktKey = null;
					_this.wktExpiration = null;
				}

				_this.limparOutrasTelas();
				_this.buscarGruposInformacoesWkt();
			});
		},


		/**
   * Método utilizado para inspeção utilizando o botão direito do mouse no mapa.
   */
		inspecionarPonto: function inspecionarPonto(e) {

			this.abrirTela('PONTO');

			this.$refs.PONTO.inspecionarGeometria({
				type: 'Point',
				coordinates: [e.latlng.lng, e.latlng.lat]
			});

			this.inspecionar();
		},


		/**
   * Efetua a busca no servidor pelos grupos de informações referente
   * às camadas ativas que intersecionam com gemetria vetorizada.
   */
		buscarGruposInformacoesWkt: function buscarGruposInformacoesWkt() {
			var _this2 = this;

			this.gruposInformacao = null;
			this.msgEmptyResult = null;

			var params = this.getParametrosWkt();
			params.idsCamadas = _.map(this.camadasAtivas, 'id');

			if (!params.idsCamadas || !params.idsCamadas.length) {

				this.pesquisaEfetuada = false;
				return;
			}

			__WEBPACK_IMPORTED_MODULE_7__services_camadasService__["a" /* default */].findGrupoInformacoesByWKT(params, function (result) {

				_this2.pesquisaEfetuada = true;
				_this2.gruposInformacao = result.data || [];
				_this2.wktKey = result.wktKey;
				_this2.wktExpiration = result.wktExpiration;
			}, this.getRequestErrorHandler('Não foi possível efetuar a pesquisa.'), requestOptions);
		},


		/**
   * Busca os registros de uma camada (grupo) selecionada na listagem de grupos.
   */
		buscarInformacoesWktCamada: function buscarInformacoesWktCamada(paginaAtual) {
			var _this3 = this;

			if (!this.grupo) return;

			var params = this.getParametrosWkt();
			params.idsCamadas = [this.grupo.camada.id];
			params.pagina = paginaAtual || PAGINA_INICIAL;

			__WEBPACK_IMPORTED_MODULE_7__services_camadasService__["a" /* default */].findInformacoesByWKT(params, function (result) {

				_this3.paginacaoRegistros = result.data;
				_this3.wktKey = result.wktKey;
				_this3.wktExpiration = result.wktExpiration;
			}, this.getRequestErrorHandler('Não foi possível efetuar a pesquisa.'), requestOptions);
		},


		/**
   * Retorna objeto contendo qual parâmetro (wkt ou wktKey) deve ser enviado nas requisições.
   */
		getParametrosWkt: function getParametrosWkt() {

			if (this.wktKey && this.wktExpiration && this.wktExpiration > new Date()) {

				return { wktKey: this.wktKey };
			} else {

				return { wkt: this.wkt };
			}
		},


		/**
   * Acionado quando o usuário clica em um dos ítens da listagem de grupos
   * de informação, retornados pela pesquisa. Busca os registros da camada
   * e as exibe.
   */
		exibirGrupo: function exibirGrupo(e) {

			this.limparPaginacaoRegistros();
			this.grupo = e.grupo;
			this.buscarInformacoesWktCamada();
		},


		/**
   * Oculta um grupo retornando à listagem de grupos.
   */
		ocultarGrupo: function ocultarGrupo() {

			if (this.$refs.listagemRegistros) this.$refs.listagemRegistros.limpar();
			this.limparPaginacaoRegistros();
			this.grupo = null;
		},


		/**
   * Limpa as informações referentes à paginação.
   */
		limparPaginacaoRegistros: function limparPaginacaoRegistros() {

			if (this.$refs.paginacaoRegistros) this.$refs.paginacaoRegistros.setPage(PAGINA_INICIAL);
			this.paginacaoRegistros = null;
		},


		/**
   * Método utilizado na paginação de registros de camada para abrir uma pãgina.
   */
		alterarPaginaRegistros: function alterarPaginaRegistros(pagina) {

			this.buscarInformacoesWktCamada(pagina);
		},


		/**
   * Exibe os detalhes de um registro.
   */
		exibirRegistro: function exibirRegistro(e) {

			this.registro = e.registro;
		},


		/**
   * Oculta o registro exibido, retornando à listagem de registros de uma camada.
   */
		ocultarRegistro: function ocultarRegistro() {

			this.registro = null;
		},


		/**
   * Retorna uma função para tratar os erros de requisição.
   */
		getRequestErrorHandler: function getRequestErrorHandler(defaultMessage) {
			var _this4 = this;

			return function (result) {
				_this4.mensagemErro = result.texto || defaultMessage;
				_this4.showAlert = true;
			};
		},


		/**
   * Retorna o componente referente à ferramenta de inspeção selecionada
   * (shape, polígono e ponto).
   */
		getTelaAtual: function getTelaAtual() {

			return this.$refs[this.tela];
		},


		/**
   * Limpa todas as ferramentas de inspeção, exceto a selecionada atualmente.
   */
		limparOutrasTelas: function limparOutrasTelas() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {

				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.telas), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var nomeTela = _step.value;


					if (nomeTela !== this.tela) {

						this.$refs[nomeTela].limpar();
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}
		},


		/**
   * Limpa todas as ferramentas de inspeção.
   */
		limpar: function limpar() {

			this.getTelaAtual().limpar();
			this.limparOutrasTelas();
			this.showAlert = false;
		},


		/*
   * Exportar o resultado da pesquisa em CSV ( Sem paginação )
   */
		exportarCSV: function exportarCSV() {
			var _this5 = this;

			var params = this.getParametrosWkt();
			params.idsCamadas = [this.grupo.camada.id];

			__WEBPACK_IMPORTED_MODULE_7__services_camadasService__["a" /* default */].exportCSVInformacoesCamadaByWKT(params, function (result) {

				// Solução temporária, pois o AXIOS ( API de REST utilizada pelo sistema ) não
				// da suporte pra chunked streaming
				var downloadName = 'informacoes-' + _this5.grupo.camada.nome.toLowerCase() + '-' + _this5.dataAtualFormatada + '.csv';
				var file = new File([result.data], downloadName, { type: 'text/csv' });
				__WEBPACK_IMPORTED_MODULE_13_file_saver___default.a.saveAs(file);
			}, this.getRequestErrorHandler('Não foi possível gerar o arquivo CSV.'), requestOptionsCSV);
		},


		// Método chamado pelo componente pai (ToolBox)
		beforeComponentHide: function beforeComponentHide() {

			this.limpar();
		}
	},

	computed: {
		camadasAtivas: function camadasAtivas() {
			return this.$store.getters.camadasAtivasSig;
		},


		/** Gera a data atual */
		dataAtualFormatada: function dataAtualFormatada() {

			var data = new Date();

			var dia = data.getDate();

			if (dia.toString().length === 1) dia = '0' + dia;

			var mes = data.getMonth() + 1;

			if (mes.toString().length === 1) mes = '0' + mes;

			var ano = data.getFullYear();

			return dia + '-' + mes + '-' + ano;
		}
	}
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(10)))

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_InputErrors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utils_InputErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_utils_InputErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_DrawButton__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_DrawButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils_DrawButton__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_estilo__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_drawUtils__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_markerStyles__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_leafletUtils__ = __webpack_require__(30);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'InspecaoGeometria',

	components: { InputErrors: __WEBPACK_IMPORTED_MODULE_0__components_utils_InputErrors___default.a, DrawButton: __WEBPACK_IMPORTED_MODULE_1__components_utils_DrawButton___default.a },

	props: {
		tipoGeometria: {
			type: Object,
			required: true
		},
		maxAreaHA: {
			type: Number,
			required: true
		}
	},

	data: function data() {
		return {
			geometria: null,
			validacaoExecutada: false,
			drawTool: __WEBPACK_IMPORTED_MODULE_4__utils_drawUtils__["a" /* default */].POLYGON_TOOL,
			erro: null
		};
	},


	/**
  * Configura o tipo de ferramenta de desenho de acordo com o tipo de Geometria
  */
	created: function created() {

		if (this.tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].POLIGONO.codigo) {

			this.drawTool = __WEBPACK_IMPORTED_MODULE_4__utils_drawUtils__["a" /* default */].POLYGON_TOOL;
		} else if (this.tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].LINHA.codigo) {

			this.drawTool = __WEBPACK_IMPORTED_MODULE_4__utils_drawUtils__["a" /* default */].POLYLINE_TOOL;
		} else if (this.tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].PONTO.codigo) {

			this.drawTool = __WEBPACK_IMPORTED_MODULE_4__utils_drawUtils__["a" /* default */].CIRCLEMARKER_TOOL;
		}
	},


	methods: {
		inspecionarGeometria: function inspecionarGeometria(geoJson) {

			var layer = __WEBPACK_IMPORTED_MODULE_6__utils_leafletUtils__["a" /* default */].createGeoJsonLayer(geoJson);

			if (layer.getLayers && layer.getLayers().length) {

				layer = layer.getLayers()[0];
			}

			this.onGeometriaVetorizada({ layer: layer });
		},


		/**
   * Executado quando uma nova geometria é desenhada, remove a geometria anterior,
   * adiciona a nova e executa as validações.
   */
		onGeometriaVetorizada: function onGeometriaVetorizada(data) {

			this.removerGeometriasMapa();
			this.geometria = data;

			if (this.tipoGeometria.codigo !== __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].PONTO.codigo) {

				var style = __WEBPACK_IMPORTED_MODULE_3__models_estilo__["a" /* default */].getStyleInspecao(this.tipoGeometria);
				data.layer.setStyle(style);
			} else {

				this.$mapa.removeLayer(this.geometria.layer);
				this.adicionarMarcador();
			}

			this.validar();
		},


		/**
   * Utilizado no caso do tipo de geometria for PONTO, onde ao invés
   * do desenho do ponto, é adicionado ao mapa o marcador de inspeção.
   */
		adicionarMarcador: function adicionarMarcador() {

			var latlng = this.geometria.layer.getLatLng();

			this.$bus.$emit('mapa.addCoordinatePoint', {
				markerCode: 'InformacoesPonto',
				lat: latlng.lat,
				lng: latlng.lng,
				markerStyle: __WEBPACK_IMPORTED_MODULE_5__utils_markerStyles__["a" /* default */].inspecao,
				center: false,
				fixed: true
			});
		},


		/**
   * Remove as geometria do mapa. Utilizado quando o usuário alterna para outra
   * ferramenta de inspeção ou limpa o formulário.
   */
		removerGeometriasMapa: function removerGeometriasMapa() {

			if (this.tipoGeometria.codigo !== __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].PONTO.codigo) {

				if (this.geometria) this.$mapa.removeLayer(this.geometria.layer);
			} else {

				this.$bus.$emit('mapa.removeCoordinatePoint', 'InformacoesPonto');
			}
		},


		/**
   * Adiciona a geometria do mapa (se existente. Utilizado quando o usuário alterna
   * para outra ferramenta de inspeção e retorna a esta.
   */
		adicionarGeometriasMapa: function adicionarGeometriasMapa() {

			if (this.geometria) {

				if (this.tipoGeometria.codigo !== __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].PONTO.codigo) {

					this.$mapa.addLayer(this.geometria.layer);
				} else {

					this.adicionarMarcador();
				}
			}
		},


		/**
   * Valida se o usuário adicionou uma geometria e se ela não excede a área máxima
   * permitida. Chamada pelo componente pai antes de efetuar a busca por informações.
   */
		validar: function validar(callback) {

			this.erro = null;

			if (!this.geometria) {

				if (this.tipoGeometria.codigo !== __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].PONTO.codigo) {

					this.erro = 'É necessário vetorizar uma geometria.';
				} else {

					this.erro = 'É necessário marcar um ponto no mapa.';
				}

				return;
			}

			if (this.tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_2__models_tipoGeometria__["a" /* default */].POLIGONO.codigo && this.geometria.area > this.maxAreaHA) {

				this.erro = 'O polígono excede o limite máximo de ' + this.maxAreaHA + ' ha';
				return;
			}

			if (callback) callback();
		},


		/**
   * Limpa todas as informações do componente, retornando-o a seu estado inicial.
   */
		limpar: function limpar() {
			var _this = this;

			this.removerGeometriasMapa();
			this.geometria = null;
			this.erro = null;

			this.$nextTick().then(function () {
				_this.validacaoExecutada = false;
				_this.$validator.cleanErrors();
			});
		},


		/**
   * Retorna a geometria vetorizada. Método utilizado pelo componente pai para
   * efetuar a busca por informações.
   */
		getGeometria: function getGeometria() {
			return this.geometria;
		}
	}
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_leafletUtils__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_ShapeInput__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utils_ShapeInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_utils_ShapeInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_InputErrors__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utils_InputErrors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_utils_InputErrors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_estilo__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_tipoGeometria__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'InspecaoShape',

	components: { ShapeInput: __WEBPACK_IMPORTED_MODULE_1__components_utils_ShapeInput___default.a, InputErrors: __WEBPACK_IMPORTED_MODULE_2__components_utils_InputErrors___default.a },

	props: {
		maxAreaHA: {
			type: Number,
			required: true
		}
	},

	data: function data() {
		return {
			geoJsonShape: null,
			geometria: null,
			tipoGeometria: null,
			tamanhoMaximoShapeMB: __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].inspecao.tamanhoMaximoShapeMB
		};
	},


	/**
  * Configura as validações relacionadas ao shape selecionado.
  */
	mounted: function mounted() {
		var _this = this;

		this.$validator.addComponentRule(this.$refs.shapeInput, {
			getMessage: function getMessage(field) {
				return 'O shape excede o limite máximo de ' + _this.maxAreaHA + ' ha.';
			},
			validate: function validate(value) {
				return !_this.geometriaExcedeAreaMaxima();
			}
		});
	},


	methods: {

		/**
   * Executado quando um shape é selecionado, cria uma camada para ele,
   * e se passar nas validações, esta camada é adicionada ao mapa.
   */
		onShapeChange: function onShapeChange(geoJson) {
			var _this2 = this;

			this.removerGeometriasMapa();

			if (!geoJson || geoJson.msg) return;

			this.tipoGeometria = __WEBPACK_IMPORTED_MODULE_4__models_tipoGeometria__["a" /* default */].getFromGeoJson(geoJson);

			var style = __WEBPACK_IMPORTED_MODULE_3__models_estilo__["a" /* default */].getStyleInspecao(this.tipoGeometria);

			var layer = __WEBPACK_IMPORTED_MODULE_0__utils_leafletUtils__["a" /* default */].createGeoJsonLayer(geoJson, style);

			this.geometria = {
				layer: layer,
				area: __WEBPACK_IMPORTED_MODULE_0__utils_leafletUtils__["a" /* default */].getLayerArea(layer)
			};

			this.validar(function () {

				_this2.geometria.layer = _this2.getPolygonLayer();
				_this2.$mapa.addLayer(_this2.geometria.layer);

				_this2.$bus.$emit('mapa.centerLayer', _this2.geometria.layer);
			});
		},


		/**
   * Verifica se o shape informado excede à area máxima permitida.
   */
		geometriaExcedeAreaMaxima: function geometriaExcedeAreaMaxima() {

			return this.tipoGeometria && this.geometria && this.geometria.area && this.tipoGeometria.codigo === __WEBPACK_IMPORTED_MODULE_4__models_tipoGeometria__["a" /* default */].POLIGONO.codigo && this.geometria.area > this.maxAreaHA;
		},


		/**
   * Normalmente os shapes, quando convertidos para geoJson, geram uma
   * FeatureCollection contendo as geometria. Devido a isto, a layer acaba
   * por ser um layerGroup com várias sub-camadas.
   * Assim, este método verifica quantas sub-camadas o shape gerou.
   */
		getNumeroGeometrias: function getNumeroGeometrias() {

			if (!this.geometria || !this.geometria.layer) return 0;

			var layer = this.geometria.layer;
			var subLayers = layer && layer.getLayers && layer.getLayers();

			if (!subLayers) return 0;

			return subLayers.length;
		},


		/**
   * Retorna a camada que de fato contem a geometria. Ver o comentário do
   * método 'getNumeroGeometrias'.
   */
		getPolygonLayer: function getPolygonLayer() {

			if (!this.geometria || !this.geometria.layer) return null;

			if (!this.geometria.layer.getLayers) return this.geometria.layer;

			var subLayers = this.geometria.layer.getLayers();

			return subLayers.length ? subLayers[0] : null;
		},


		/**
   * Limpa todas as informações do componente, retornando-o a seu estado inicial.
   */
		limpar: function limpar() {
			var _this3 = this;

			this.removerGeometriasMapa();
			this.geometria = null;
			this.$refs.shapeInput.clear();
			this.geoJsonShape = null;

			this.$nextTick().then(function () {
				_this3.$validator.cleanErrors();
			});
		},


		/**
   * Valida se o usuário adicionou uma geometria e se ela não excede a área máxima
   * permitida. Chamada pelo componente pai antes de efetuar a busca por informações.
   */
		validar: function validar(callback) {

			this.$validator.cleanErrors();

			this.$validator.validateAll().then(function (result) {

				if (result && callback) callback();
			});
		},


		/**
   * Remove as geometria do mapa. Utilizado quando o usuário alterna para outra
   * ferramenta de inspeção ou limpa o formulário.
   */
		removerGeometriasMapa: function removerGeometriasMapa() {

			if (this.geometria) this.$mapa.removeLayer(this.geometria.layer);
		},


		/**
   * Utilizado no caso do tipo de geometria for PONTO, onde ao invés
   * do desenho do ponto, é adicionado ao mapa o marcador de inspeção.
   */
		adicionarGeometriasMapa: function adicionarGeometriasMapa() {

			if (this.geometria) this.$mapa.addLayer(this.geometria.layer);
		},


		/**
   * Retorna a geometria vetorizada. Método utilizado pelo componente pai para
   * efetuar a busca por informações.
   */
		getGeometria: function getGeometria() {

			return this.geometria;
		}
	}
});

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'Alert',

	props: {

		msg: {
			type: String,
			required: true
		},

		title: {
			type: String,
			default: 'Atenção!'
		},

		showTitle: {
			type: Boolean,
			default: true
		},

		visible: {
			type: Boolean,
			default: true
		},

		closeFunction: {
			type: Function
		},

		type: {
			type: String,
			required: true,
			validator: function validator(value) {
				return value === 'error' || value === 'success' || value === 'warning';
			}

		}
	}
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var COLOR_PALETTE_COLORS = [['#330000', '#331900', '#333300', '#193300', '#003300', '#003319', '#003333', '#001933', '#000033', '#190033', '#330033', '#330019', '#000000'], ['#660000', '#663300', '#666600', '#336600', '#006600', '#006633', '#006666', '#003366', '#000066', '#330066', '#660066', '#660033', '#202020'], ['#990000', '#994C00', '#999900', '#4C9900', '#009900', '#00994C', '#009999', '#004C99', '#000099', '#4C0099', '#990099', '#99004C', '#404040'], ['#CC0000', '#CC6600', '#CCCC00', '#66CC00', '#00CC00', '#00CC66', '#00CCCC', '#0066CC', '#0000CC', '#6600CC', '#CC00CC', '#CC0066', '#606060'], ['#FF0000', '#FF8000', '#FFFF00', '#80FF00', '#00FF00', '#00FF80', '#00FFFF', '#0080FF', '#0000FF', '#7F00FF', '#FF00FF', '#FF007F', '#808080'], ['#FF3333', '#FF9933', '#FFFF33', '#99FF33', '#33FF33', '#33FF99', '#33FFFF', '#3399FF', '#3333FF', '#9933FF', '#FF33FF', '#FF3399', '#A0A0A0'], ['#FF6666', '#FFB266', '#FFFF66', '#B2FF66', '#66FF66', '#66FFB2', '#66FFFF', '#66B2FF', '#6666FF', '#B266FF', '#FF66FF', '#FF66B2', '#C0C0C0'], ['#FF9999', '#FFCC99', '#FFFF99', '#CCFF99', '#99FF99', '#99FFCC', '#99FFFF', '#99CCFF', '#9999FF', '#CC99FF', '#FF99FF', '#FF99CC', '#E0E0E0'], ['#FFCCCC', '#FFE5CC', '#FFFFCC', '#E5FFCC', '#CCFFCC', '#CCFFE5', '#CCFFFF', '#CCE5FF', '#CCCCFF', '#E5CCFF', '#FFCCFF', '#FFCCE5', '#FFFFFF']];

/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'ColorPalette',

	props: ['value'],

	data: function data() {
		return {
			colors: COLOR_PALETTE_COLORS
		};
	},


	methods: {
		setColor: function setColor(color) {
			this.$emit('input', color);
		}
	}
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_leafletUtils__ = __webpack_require__(30);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'DrawButton',

	props: {
		label: {
			type: String,
			default: 'Desenhar'
		},

		iconClass: {
			type: String,
			default: 'mdi mdi-lead-pencil'
		},

		addLayerToMap: {
			type: Boolean,
			default: true
		},

		drawTool: {
			type: String,
			required: true
		},

		setDetails: {
			type: Boolean,
			default: false
		}
	},

	data: function data() {
		return {
			drawing: false
		};
	},


	methods: {
		draw: function draw() {
			var _this = this;

			if (this.drawing) {

				this.drawing = false;
				this.$bus.$emit('mapa.cancelDraw');
				return;
			}

			this.drawing = true;

			this.$bus.$emit('mapa.draw', {
				center: false,
				tool: this.drawTool,
				onComplete: function onComplete(layer) {

					_this.drawing = false;

					if (!_this.addLayerToMap) _this.$mapa.removeLayer(layer);

					var result = { layer: layer };

					if (_this.setDetails) _this.setLayerDetails(result);

					_this.$emit('drawComplete', result);
				},
				onCancel: function onCancel() {
					_this.drawing = false;
				}
			});
		},
		setLayerDetails: function setLayerDetails(result) {

			result.area = __WEBPACK_IMPORTED_MODULE_0__utils_leafletUtils__["a" /* default */].getLayerArea(result.layer);

			if (result.layer.getLatLng) {

				var latlng = result.layer.getLatLng();

				result.latlng = { lat: latlng.lat, lng: latlng.lng };
			}
		}
	}
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'emptyResult',
	props: ['message']
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'InputErrors',
	props: ['name', 'msg', 'errorBag', 'scope'],
	data: function data() {

		return {
			parentErrors: this.errorBag || this.$parent.errors
		};
	}
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'paginacao',

	props: {
		total: {
			type: Number,
			required: true
		},

		pageSize: {
			type: Number,
			required: true
		},

		onChange: {
			type: Function,
			required: true
		},

		options: {
			type: Object
		}
	},

	data: function data() {
		return {
			currentPage: 1
		};
	},


	computed: {
		lastPage: function lastPage() {

			var total = this.total / this.pageSize;

			if (total < 1) {

				return 1;
			}

			if (total % 1 !== 0) {

				return parseInt(total + 1);
			}

			return total;
		},
		pages: function pages() {

			var from = this.currentPage - this.config.offset;

			if (from < 1) {

				from = 1;
			}

			var to = from + this.config.offset * 2;

			if (to >= this.lastPage) {

				to = this.lastPage;
			}

			var arr = [];

			while (from <= to) {

				arr.push(from);
				from++;
			}

			return arr;
		},
		config: function config() {
			return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
				offset: 2,
				previousText: '«',
				nextText: '»'
			}, this.options);
		},
		initialInterval: function initialInterval() {

			if (this.currentPage === 1) {
				return 1;
			}

			return (this.currentPage - 1) * this.pageSize + 1;
		},
		finalInterval: function finalInterval() {

			var value = this.currentPage * this.pageSize;

			return value > this.total ? this.total : value;
		}
	},

	methods: {
		showPrevious: function showPrevious() {
			return this.config.alwaysShowPrevNext || this.currentPage > 1;
		},
		showNext: function showNext() {
			return this.config.alwaysShowPrevNext || this.currentPage < this.lastPage;
		},
		changePage: function changePage(page) {

			if (this.currentPage === page) return;

			this.setPage(page);

			this.onChange(page);
		},
		setPage: function setPage(page) {

			this.currentPage = page;
		}
	}
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shpjs__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shpjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_shpjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_geoJsonUtil__ = __webpack_require__(223);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

	name: 'ShapeInput',

	props: {

		value: Object,

		maxFileSize: {
			type: Number,
			default: 100
		},

		acceptPolygons: {
			type: Boolean,
			default: false
		},

		acceptPoints: {
			type: Boolean,
			default: false
		},

		acceptLineStrings: {
			type: Boolean,
			default: false
		},

		maxGeometries: {
			type: Number,
			default: -1
		}
	},

	inject: ['$validator'],

	data: function data() {
		return {
			fileName: null,
			file: null,
			reader: null,
			error: null,
			loading: false
		};
	},
	mounted: function mounted() {

		var that = this;

		this.$validator.addComponentRule(this, {
			getMessage: function getMessage(field) {
				return that.error && that.error.msg || 'Não foi possível processar o arquivo shape selecionado.';
			},
			validate: function validate(value) {
				return !that.error;
			}
		});
	},


	methods: {
		clear: function clear() {
			this.fileName = null;
			this.file = null;
			this.reader = null;
			this.error = null;
			this.loading = false;
			this.$refs.inputFile.value = '';
		},
		selectFile: function selectFile() {

			this.$refs.inputFile.click();
		},
		onChange: function onChange(evt) {
			var _this = this;

			if (!this.$refs.inputFile.files || this.$refs.inputFile.files.length === 0) return;

			this.file = this.$refs.inputFile.files[0];
			this.fileName = this.file.name;
			this.error = null;

			if (this.file.size > this.maxFileSizeInBytes) {

				this.handleError({ msg: 'O shape selecionado excede o tamanho máximo de ' + this.maxFileSize + ' MB.' });
				return;
			}

			this.loading = true;

			setTimeout(function () {
				_this.handleFile(_this.file);
			}, 1);
		},
		handleFile: function handleFile(file) {

			this.reader = new FileReader();
			var that = this;
			var extension = file.name.slice(-3);

			this.reader.onload = function () {

				if (this.readyState !== 2 || this.error) {

					this.handleError(this.error);
				} else {

					if (extension === 'zip') {
						that.parseZipData(this.result);
					} else {
						that.parseShpData(this.result);
					}
				}
			};

			this.$emit('startLoading');
			this.reader.readAsArrayBuffer(file);
		},
		parseZipData: function parseZipData(data) {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_1_shpjs___default()(data).then(function (geoJson) {

				_this2.loading = false;
				_this2.submitGeoJson(geoJson);
			}, function (e) {

				_this2.handleError(e);
			});
		},
		parseShpData: function parseShpData(data, cb, scope) {

			try {
				var geometries = __WEBPACK_IMPORTED_MODULE_1_shpjs___default.a.parseShp(data);
				this.loading = false;

				var geoJson = {
					type: 'FeatureCollection',
					features: [],
					fileName: this.fileName
				};

				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(geometries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var geometry = _step.value;


						geoJson.features.push({
							type: 'Feature',
							geometry: geometry
						});
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				this.submitGeoJson(geoJson);
			} catch (e) {

				this.handleError(e);
			}
		},
		submitGeoJson: function submitGeoJson(geoJson) {

			var details = __WEBPACK_IMPORTED_MODULE_2__utils_geoJsonUtil__["a" /* default */].getDetails(geoJson);
			var error = null;

			if (details.totalGeometries === 0) {

				error = 'O shape selecionado não possui geometrias.';
			} else if (!this.validateGeometryType(details)) {

				error = this.typesErrorMsg;
			} else if (this.maxGeometries > 0 && details.totalGeometries > this.maxGeometries) {

				error = 'O shape deve conter no máximo ' + this.maxGeometries + (this.maxGeometries > 1 ? ' geometrias.' : ' geometria.');
			}

			if (error) {

				this.handleError({ msg: error });
			} else {

				this.$emit('input', geoJson);
			}
		},
		validateGeometryType: function validateGeometryType(details) {

			if (this.acceptAllTypes) return true;

			return (!details.isPolygon || this.acceptPolygons) && (!details.isPoint || this.acceptPoints) && (!details.isLineString || this.acceptLineStrings) && (details.isPolygon || details.isPoint || details.isLineString);
		},
		handleError: function handleError(error) {

			this.loading = false;
			this.error = error;
			this.$emit('input', error);
		}
	},

	computed: {
		maxFileSizeInBytes: function maxFileSizeInBytes() {

			return this.maxFileSize * 1024 * 1024;
		},
		acceptAllTypes: function acceptAllTypes() {

			return !this.acceptPolygons && !this.acceptPoints && !this.acceptLineStrings;
		},
		typesErrorMsg: function typesErrorMsg() {

			if (this.acceptAllTypes) return '';

			var types = [];

			if (this.acceptPolygons) types.push('polígonos');
			if (this.acceptLineStrings) types.push('linhas');
			if (this.acceptPoints) types.push('pontos');

			var msg = 'O shape selecionado deve conter apenas ';

			if (types.length === 1) {

				msg += types[0];
			} else {

				for (var i = 0; i < types.length - 1; i++) {

					if (i > 0) msg += ', ';
					msg += types[i];
				}

				msg += ' ou ' + types[types.length - 1];
			}

			return msg + '.';
		}
	}
});

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 317 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 324 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 330 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */
/***/ (function(module, exports) {

module.exports = {"_from":"proj4@^2.1.4","_id":"proj4@2.4.4","_inBundle":false,"_integrity":"sha512-yo6qTpBQXnxhcPopKJeVwwOBRzUpEa3vzSFlr38f5mF4Jnfb6NOL/ePIomefWiZmPgkUblHpcwnWVMB8FS3GKw==","_location":"/proj4","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"proj4@^2.1.4","name":"proj4","escapedName":"proj4","rawSpec":"^2.1.4","saveSpec":null,"fetchSpec":"^2.1.4"},"_requiredBy":["/shpjs"],"_resolved":"https://registry.npmjs.org/proj4/-/proj4-2.4.4.tgz","_shasum":"c03d825e380f6850a4a7af5d20d365f6b72c4042","_spec":"proj4@^2.1.4","_where":"/home/fernandosimeone/Projetos/produto/sig/frontend/node_modules/shpjs","author":"","bugs":{"url":"https://github.com/proj4js/proj4js/issues"},"bundleDependencies":false,"contributors":[{"name":"Mike Adair","email":"madair@dmsolutions.ca"},{"name":"Richard Greenwood","email":"rich@greenwoodmap.com"},{"name":"Calvin Metcalf","email":"calvin.metcalf@gmail.com"},{"name":"Richard Marsden","url":"http://www.winwaed.com"},{"name":"T. Mittan"},{"name":"D. Steinwand"},{"name":"S. Nelson"}],"dependencies":{"mgrs":"1.0.0","wkt-parser":"^1.2.0"},"deprecated":false,"description":"Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.","devDependencies":{"chai":"~1.8.1","curl":"git://github.com/cujojs/curl.git","grunt":"^1.0.1","grunt-cli":"~0.1.13","grunt-contrib-connect":"~0.6.0","grunt-contrib-jshint":"~1.1.0","grunt-contrib-uglify":"~0.11.1","grunt-mocha-phantomjs":"~0.4.0","grunt-rollup":"^1.0.1","istanbul":"~0.2.4","mocha":"~1.17.1","rollup":"^0.41.4","rollup-plugin-json":"^2.0.1","rollup-plugin-node-resolve":"^2.0.0","tin":"~0.4.0"},"directories":{"test":"test","doc":"docs"},"homepage":"https://github.com/proj4js/proj4js#readme","license":"MIT","main":"dist/proj4-src.js","module":"lib/index.js","name":"proj4","repository":{"type":"git","url":"git://github.com/proj4js/proj4js.git"},"scripts":{"build":"grunt","build:tmerc":"grunt build:tmerc","test":"npm run build && istanbul test _mocha test/test.js"},"version":"2.4.4"}

/***/ }),
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(228),
  /* template */
  __webpack_require__(493),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fa2ae950",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(321)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(229),
  /* template */
  __webpack_require__(470),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(230),
  /* template */
  __webpack_require__(491),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(323)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(232),
  /* template */
  __webpack_require__(472),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2328522c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(233),
  /* template */
  __webpack_require__(486),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(235),
  /* template */
  __webpack_require__(468),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(316)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(464),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(331)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(237),
  /* template */
  __webpack_require__(482),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-68bde998",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(327)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(238),
  /* template */
  __webpack_require__(476),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(240),
  /* template */
  __webpack_require__(478),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(241),
  /* template */
  __webpack_require__(495),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(320)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(242),
  /* template */
  __webpack_require__(469),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1848f100",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(243),
  /* template */
  __webpack_require__(484),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(244),
  /* template */
  __webpack_require__(471),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(245),
  /* template */
  __webpack_require__(480),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c8137d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(246),
  /* template */
  __webpack_require__(475),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2cbfc9ac",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(247),
  /* template */
  __webpack_require__(467),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(249),
  /* template */
  __webpack_require__(492),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f83ce66c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(250),
  /* template */
  __webpack_require__(489),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b993db40",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(324)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(473),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2420906f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(252),
  /* template */
  __webpack_require__(463),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Arquivo shape:")]), _c('shape-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "shapeInput",
    attrs: {
      "name": "shape",
      "max-file-size": _vm.tamanhoMaximoShapeMB,
      "max-geometries": 1,
      "accept-polygons": true
    },
    on: {
      "input": _vm.onShapeChange
    },
    model: {
      value: (_vm.geoJsonShape),
      callback: function($$v) {
        _vm.geoJsonShape = $$v
      },
      expression: "geoJsonShape"
    }
  }), _c('input-errors', {
    attrs: {
      "name": "shape"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'level-1': _vm.registro
    },
    attrs: {
      "id": "pesquisaCamada"
    }
  }, [_c('div', {
    staticClass: "float-box-view-level-0"
  }, [_vm._m(0, false, false), _c('alert', {
    staticClass: "mb-0",
    attrs: {
      "msg": "Não há camadas passíveis de pesquisa.",
      "visible": !_vm.pesquisaLiberada,
      "type": "warning"
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pesquisaLiberada),
      expression: "pesquisaLiberada"
    }],
    staticClass: "col-md-12 float-box-title-extras filtro-pesquisa"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateAndSearch()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Camada:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.camada),
      expression: "camada"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "disabled": !_vm.pesquisaLiberada,
      "name": "camada"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.camada = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onCamadaChange()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled",
      "selected": "selected"
    }
  }, [_vm._v("Selecionar")]), _vm._l((_vm.camadasPesquisaveis), function(camada) {
    return _c('option', {
      domProps: {
        "value": camada
      }
    }, [_vm._v(_vm._s(camada.nome))])
  })], 2), _c('input-errors', {
    attrs: {
      "name": "camada"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Atributo:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.atributo),
      expression: "atributo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "disabled": !_vm.pesquisaLiberada || !_vm.camada,
      "name": "atributo"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.atributo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.onAtributoChange()
      }]
    }
  }, [(_vm.atributos && _vm.atributos.length > 0) ? _c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled",
      "selected": "selected"
    }
  }, [_vm._v("Selecionar")]) : _vm._e(), (!_vm.atributos || _vm.atributos.length === 0) ? _c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled"
    }
  }, [_vm._v("Camada selecionada não possui atributos")]) : _vm._e(), _vm._l((_vm.atributos), function(atributo) {
    return _c('option', {
      domProps: {
        "value": atributo
      }
    }, [_vm._v(_vm._s(atributo.nome))])
  })], 2), _c('input-errors', {
    attrs: {
      "name": "atributo"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Pesquisa:")]), (!_vm.atributo || _vm.atributo.tipo !== _vm.TipoAtributoCamada.BOOLEANO) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validator),
      expression: "validator"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "name": "filtro",
      "disabled": !_vm.pesquisaLiberada || !_vm.atributo
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  }) : _vm._e(), _c('input-errors', {
    attrs: {
      "name": "filtro"
    }
  }), (_vm.atributo && _vm.atributo.tipo === _vm.TipoAtributoCamada.BOOLEANO) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "name": "filtroBoolean"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.filtro = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "disabled",
      "selected": "selected"
    }
  }, [_vm._v("Selecionar")]), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Sim")]), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Não")])]) : _vm._e(), _c('input-errors', {
    attrs: {
      "name": "filtroBoolean"
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm float-right",
    attrs: {
      "type": "button",
      "disabled": !_vm.pesquisaLiberada
    },
    on: {
      "click": function($event) {
        _vm.validateAndSearch()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v(" Pesquisa")]), _c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "type": "button",
      "disabled": !_vm.pesquisaLiberada
    },
    on: {
      "click": function($event) {
        _vm.clean()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-eraser"
  }), _vm._v(" Limpar")])])])])]), _c('div', {
    staticClass: "float-box-content content-pesquisa"
  }, [(_vm.pesquisaEfetuada) ? _c('listagem-registros', {
    ref: "listagemRegistros",
    attrs: {
      "registros": _vm.registrosPesquisa,
      "showMarkers": true
    },
    on: {
      "exibirRegistro": _vm.exibirRegistro
    }
  }) : _vm._e()], 1), (_vm.registrosPesquisa && _vm.registrosPesquisa.length > 0) ? _c('div', {
    staticClass: "float-box-footer"
  }, [_c('paginacao', {
    ref: "paginacao",
    attrs: {
      "total": _vm.paginacao.totalItens,
      "page-size": _vm.paginacao.itensPorPagina,
      "onChange": _vm.alterarPagina,
      "options": _vm.paginationOptions
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "float-box-view-level-1"
  }, [(_vm.registro) ? _c('visualizacao-registro-camada', {
    attrs: {
      "registro": _vm.registro,
      "showReturnButton": true
    },
    on: {
      "close": function($event) {
        _vm.ocultarRegistro()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_c('i', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v("Pesquisa")])])
}]}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [(_vm.registroVisualizacao) ? _c('h2', {
    staticClass: "pull-left"
  }, [(_vm.showReturnButton) ? _c('i', {
    staticClass: "fa fa-chevron-left action-icon",
    on: {
      "click": function($event) {
        _vm.ocultarRegistro()
      }
    }
  }) : _vm._e(), (!_vm.showReturnButton) ? _c('i', {
    staticClass: "mdi mdi-map-marker"
  }) : _vm._e(), _c('span', {
    attrs: {
      "title": _vm.registroVisualizacao.titulo
    }
  }, [_vm._v(_vm._s(_vm.registroVisualizacao.titulo || _vm.registroVisualizacao.nomeCamada))])]) : _vm._e()]), _c('div', {
    staticClass: "float-box-content default-padding col-md-12",
    attrs: {
      "id": "informacoesRegistro"
    }
  }, [(_vm.registroVisualizacao) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Camada:")]), _c('p', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.registroVisualizacao.nomeCamada))])]), _vm._l((_vm.registroVisualizacao.atributos), function(atr) {
    return (_vm.registroVisualizacao && _vm.registroVisualizacao.atributos && _vm.registroVisualizacao.atributos.length) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', [_vm._v(_vm._s(atr.nome) + ":")]), _c('p', {
      staticClass: "form-control-static"
    }, [_vm._v(_vm._s(atr.valor !== null ? atr.valor : '-'))])]) : _vm._e()
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.camada.possuiUrlMaisInformacoes),
      expression: "camada.possuiUrlMaisInformacoes"
    }],
    staticClass: "form-group"
  }, [_c('label', [_c('a', {
    attrs: {
      "href": _vm.urlMaisInformacoes,
      "target": "_blank"
    }
  }, [_vm._v("Mais informações")])])])], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "shape-input"
  }, [_c('div', {
    staticClass: "input-group",
    attrs: {
      "title": _vm.fileName
    },
    on: {
      "click": function($event) {
        _vm.selectFile()
      }
    }
  }, [_vm._m(0, false, false), _c('input', {
    ref: "inputFile",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "inputFile",
      "type": "file",
      "accept": ".zip, .shp, .SHP"
    },
    on: {
      "change": _vm.onChange
    }
  }), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "readonly": "true"
    },
    domProps: {
      "value": _vm.fileName
    }
  })]), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.file),
      expression: "!file"
    }],
    staticClass: "text-muted"
  }, [_vm._v("Shapes de até " + _vm._s(_vm.maxFileSize) + " MB nos formatos shp ou zip.")]), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.file && !_vm.loading && !_vm.error),
      expression: "file && !loading && !error"
    }],
    staticClass: "text-success"
  }, [_vm._v("Shape carregado com sucesso.")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-striped progress-bar-animated",
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "75",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("Processando arquivo")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-prepend input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-folder-open"
  }), _vm._v(" Selecionar")])])
}]}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'camadas-tree': _vm.level == 0
    }
  }, [(_vm.level > 0) ? _c('div', {
    staticClass: "camadas-tree-item",
    class: [{
      'camadas-tree-item-active': (_vm.isGrupo && _vm.open) || (!_vm.isGrupo && _vm.model.habilitado),
      'camadas-tree-grupo': _vm.isGrupo,
      'camadas-tree-camada': !_vm.isGrupo,
      'last-item': _vm.last
    }, _vm.model.cssClass ? _vm.model.cssClass : ''],
    on: {
      "click": function($event) {
        _vm.onClick()
      }
    }
  }, [_vm._l((_vm.indents), function(showTreeLine) {
    return _c('div', {
      staticClass: "camadas-indent"
    }, [(showTreeLine) ? _c('div', {
      staticClass: "tree-line"
    }) : _vm._e()])
  }), (_vm.level > 1) ? _c('div', {
    staticClass: "camadas-indent last-indent"
  }, [_c('div', {
    staticClass: "tree-line"
  }), _c('hr')]) : _vm._e(), (_vm.isGrupo) ? _c('div', {
    staticClass: "camadas-tree-item-nome"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-folder-open': _vm.open, 'fa-folder': !_vm.open
    }
  }), _vm._v(_vm._s(_vm.model.nome)), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open && _vm.hasChildren),
      expression: "open && hasChildren"
    }],
    staticClass: "complementar-tree-line"
  })]) : _vm._e(), (!_vm.isGrupo) ? _c('div', {
    staticClass: "dtable-cell camadas-tree-item-nome"
  }, [_c('label', {
    staticClass: "custom-control custom-checkbox"
  }, [_c('input', {
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.model.habilitado
    },
    on: {
      "change": function($event) {
        _vm.onCamadaCheck()
      }
    }
  }), _c('span', {
    staticClass: "custom-control-indicator"
  }), _c('span', {
    staticClass: "custom-control-description"
  }, [_vm._v(_vm._s(_vm.model.nome))])])]) : _vm._e()], 2) : _vm._e(), _c('div', {
    staticClass: "camadas-tree-children",
    class: {
      'closed': !_vm.open
    }
  }, [_vm._l((_vm.model.grupos), function(grupo, index) {
    return (_vm.model.grupos) ? _c('camadas-tree', {
      key: grupo._key,
      ref: 'tree-item-' + grupo._key,
      refInFor: true,
      attrs: {
        "model": grupo,
        "grupo-pai": _vm.model,
        "level": _vm.level + 1,
        "first": index === 0,
        "last": index === _vm.model.grupos.length - 1 && _vm.model.camadas.length === 0,
        "indents": _vm.childIndents,
        "emitter": _vm.eventEmitter
      },
      on: {
        "open": _vm.onOpen
      }
    }) : _vm._e()
  }), _vm._l((_vm.model.camadas), function(camada, index) {
    return (_vm.model.camadas) ? _c('camadas-tree', {
      key: camada.id,
      attrs: {
        "model": camada,
        "grupo-pai": _vm.model,
        "level": _vm.level + 1,
        "first": index === 0,
        "last": index === _vm.model.camadas.length - 1,
        "indents": _vm.childIndents,
        "emitter": _vm.eventEmitter
      },
      on: {
        "open": _vm.onOpen
      }
    }) : _vm._e()
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "mapa"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Nome:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "name": "nome"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  }), _c('input-errors', {
    attrs: {
      "name": "nome"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Cor:")]), _c('color-palette', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "cor"
    },
    on: {
      "input": _vm.onCorChange
    },
    model: {
      value: (_vm.cor),
      callback: function($$v) {
        _vm.cor = $$v
      },
      expression: "cor"
    }
  }), _c('input-errors', {
    attrs: {
      "name": "cor"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Vetorização:")]), _c('div', [_c('draw-button', {
    staticClass: "col-md-12",
    attrs: {
      "drawTool": _vm.drawTool
    },
    on: {
      "drawComplete": _vm.onGeometriaVetorizada
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validacaoExecutada && (!this.geometrias || this.geometrias.length === 0)),
      expression: "validacaoExecutada && (!this.geometrias || this.geometrias.length === 0)"
    }],
    staticClass: "invalid-field"
  }, [_vm._v(" É necessário vetorizar ao menos uma geometria.")])], 1)]), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.geometrias && _vm.geometrias.length),
      expression: "geometrias && geometrias.length"
    }],
    staticClass: "list-group"
  }, _vm._l((_vm.geometrias), function(geom, index) {
    return _c('li', {
      staticClass: "list-group-item",
      on: {
        "mouseenter": function($event) {
          _vm.onGeometriaMouseEnter(index)
        },
        "mouseleave": function($event) {
          _vm.onGeometriaMouseLeave(index)
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.tipoGeometria.nome + ' ' + (index + 1))), _c('i', {
      staticClass: "action-icon mdi mdi-window-close",
      on: {
        "click": function($event) {
          _vm.removerGeometria(index)
        }
      }
    })])
  })), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  }), _vm._v(" Cancelar")]), _c('button', {
    staticClass: "btn btn-primary btn-sm float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adicionarCamada()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-check"
  }), _vm._v(" Adicionar")])])])])
},staticRenderFns: []}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "bottomBar"
    }
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('base-map-select')], 1), _c('div', {
    staticClass: "col-4"
  }, [_c('coordinates', {
    staticClass: "d-flex justify-content-center"
  })], 1), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('zoom-select')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-box-content col-12"
  }, [_c('ul', {
    staticClass: "nav justify-content-center nav-icons row"
  }, [_c('li', {
    staticClass: "nav-item col-3"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'SHAPE'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('SHAPE')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-upload"
  }), _c('small', [_vm._v("Shape")])])]), _c('li', {
    staticClass: "nav-item col-3"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'POLIGONO'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('POLIGONO')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-vector-square"
  }), _c('small', [_vm._v("Polígono")])])]), _c('li', {
    staticClass: "nav-item col-3"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'LINHA'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('LINHA')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-vector-line"
  }), _c('small', [_vm._v("Linha")])])]), _c('li', {
    staticClass: "nav-item col-3"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'PONTO'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('PONTO')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-crosshairs-gps"
  }), _c('small', [_vm._v("Ponto")])])])]), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSuccess),
      expression: "showSuccess"
    }],
    staticClass: "alert-sm",
    attrs: {
      "msg": "Nova camada adicionada com sucesso.",
      "type": "success",
      "showTitle": false,
      "closeFunction": _vm.hideSuccess
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'SHAPE'),
      expression: "tela === 'SHAPE'"
    }],
    staticClass: "float-box-default-padding"
  }, [_c('adicao-camada-shape', {
    ref: "SHAPE",
    on: {
      "adicionarCamada": _vm.adicionarCamada,
      "limpar": _vm.hideSuccess
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'POLIGONO'),
      expression: "tela === 'POLIGONO'"
    }],
    staticClass: "float-box-default-padding"
  }, [_c('adicao-camada-geometria', {
    ref: "POLIGONO",
    attrs: {
      "tipoGeometria": _vm.TipoGeometria.POLIGONO
    },
    on: {
      "adicionarCamada": _vm.adicionarCamada,
      "limpar": _vm.hideSuccess
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'LINHA'),
      expression: "tela === 'LINHA'"
    }],
    staticClass: "float-box-default-padding"
  }, [_c('adicao-camada-geometria', {
    ref: "LINHA",
    attrs: {
      "tipoGeometria": _vm.TipoGeometria.LINHA
    },
    on: {
      "adicionarCamada": _vm.adicionarCamada,
      "limpar": _vm.hideSuccess
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'PONTO'),
      expression: "tela === 'PONTO'"
    }],
    staticClass: "float-box-default-padding"
  }, [_c('adicao-camada-geometria', {
    ref: "PONTO",
    attrs: {
      "tipoGeometria": _vm.TipoGeometria.PONTO
    },
    on: {
      "adicionarCamada": _vm.adicionarCamada,
      "limpar": _vm.hideSuccess
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'expanded': _vm.expanded, 'collapsed': !_vm.expanded
    },
    attrs: {
      "id": "header"
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "mdi mdi-close action-icon",
    on: {
      "click": function($event) {
        _vm.expanded = false
      }
    }
  }), _c('img', {
    attrs: {
      "src": __webpack_require__(441)
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "col-12 informacoes-sig"
  }, [_c('p', {
    staticClass: "text-justify"
  }, [_vm._v(_vm._s(_vm.informacoes))])])])
},staticRenderFns: []}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Vetorização:")]), _c('div', [_c('draw-button', {
    staticClass: "col-md-12",
    attrs: {
      "drawTool": _vm.drawTool,
      "name": "drawButton",
      "setDetails": true
    },
    on: {
      "drawComplete": _vm.onGeometriaVetorizada
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.erro),
      expression: "erro"
    }],
    staticClass: "invalid-field"
  }, [_vm._v(_vm._s(_vm.erro))])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('sig-header'), _c('mapa'), _c('bottom-bar'), _c('search-box', {
    attrs: {
      "tools": _vm.searchTools
    }
  }), _c('tool-box', {
    attrs: {
      "tools": _vm.tools
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 float-box-title-extras"
  }, [_c('hr'), _c('form', [_c('div', {
    staticClass: "input-group input-group-sm invisible-addon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "camadas-filter",
      "type": "text",
      "placeholder": "Procure por uma camada..."
    },
    domProps: {
      "value": (_vm.filtro)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtro = $event.target.value
      }
    }
  }), (!_vm.filtro) ? _c('div', {
    staticClass: "input-group-addon",
    on: {
      "click": function($event) {
        _vm.setFocusFiltro()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-magnify"
  })]) : _vm._e(), (_vm.filtro) ? _c('div', {
    staticClass: "input-group-addon",
    attrs: {
      "title": "Limpar"
    },
    on: {
      "click": function($event) {
        _vm.limparFiltro()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close action-icon"
  })]) : _vm._e()])])]), _c('nav', {
    staticClass: "nav nav-tabs float-box-nav"
  }, [_c('a', {
    staticClass: "col-md-6 nav-link text-center",
    class: {
      active: _vm.tela === _vm.ESTRUTURA
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setTela(_vm.ESTRUTURA)
      }
    }
  }, [_vm._v("Todas")]), _c('a', {
    staticClass: "col-md-6 nav-link text-center",
    class: {
      active: _vm.tela === _vm.ATIVAS
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.setTela(_vm.ATIVAS)
      }
    }
  }, [_vm._v("Ativas")])]), _c('div', {
    staticClass: "float-box-content content-camadas"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === _vm.ESTRUTURA),
      expression: "tela === ESTRUTURA"
    }],
    staticClass: "col-md-12"
  }, [(_vm.estruturaCamadas) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 float-box-content-menu d-flex flex-row-reverse"
  }, [_c('div', {
    staticClass: "action-link",
    on: {
      "click": function($event) {
        _vm.collapseAll()
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-collapse"
  }), _vm._v(" Contrair")]), _c('div', {
    staticClass: "action-link",
    on: {
      "click": function($event) {
        _vm.expandAll()
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-arrow-expand"
  }), _vm._v(" Expandir")])])]) : _vm._e(), (_vm.estruturaCamadas) ? _c('camadas-tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.filtro),
      expression: "!filtro"
    }],
    ref: "camadasTree",
    attrs: {
      "model": _vm.estruturaCamadas
    }
  }) : _vm._e(), (_vm.estruturaCamadas) ? _c('camadas-tree', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filtro),
      expression: "filtro"
    }],
    attrs: {
      "model": _vm.camadasFiltradas
    }
  }) : _vm._e()], 1), _c('empty-result', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === _vm.ESTRUTURA && _vm.filtro && !(_vm.camadasFiltradas && _vm.camadasFiltradas.camadas && _vm.camadasFiltradas.camadas.length)),
      expression: "tela === ESTRUTURA && filtro && !(camadasFiltradas \t\t\t\t\t&& camadasFiltradas.camadas && camadasFiltradas.camadas.length)"
    }],
    staticClass: "full-height",
    attrs: {
      "message": "Nenhuma camada encontrada."
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === _vm.ATIVAS),
      expression: "tela === ATIVAS"
    }],
    staticClass: "camadas-ativas"
  }, [(_vm.possuiCamadasUsuario) ? _c('div', {
    staticClass: "float-box-section-title col-md-12"
  }, [_c('label', [_vm._v("Minhas Camadas")]), _c('hr')]) : _vm._e(), (_vm.possuiCamadasUsuario) ? _c('draggable', {
    attrs: {
      "list": _vm.camadasAtivas,
      "options": {
        draggable: '.camada-ativa-wrapper',
        handle: '.col-camada-drag-icon'
      }
    },
    on: {
      "change": _vm.onCamadaMoved
    }
  }, _vm._l((_vm.camadasAtivas), function(c) {
    return (c.camadaUsuario) ? _c('div', {
      staticClass: "camada-ativa-wrapper"
    }, [_c('camada-ativa', {
      attrs: {
        "camada": c
      },
      on: {
        "remove": function($event) {
          _vm.removerCamada(c)
        }
      }
    })], 1) : _vm._e()
  })) : _vm._e(), (_vm.possuiCamadasUsuario) ? _c('div', {
    staticClass: "float-box-section-title col-md-12"
  }, [_c('label', [_vm._v("Camadas SIG")]), _c('hr')]) : _vm._e(), _c('draggable', {
    attrs: {
      "list": _vm.camadasAtivas,
      "options": {
        draggable: '.camada-ativa-wrapper',
        handle: '.col-camada-drag-icon'
      }
    },
    on: {
      "change": _vm.onCamadaMoved
    }
  }, _vm._l((_vm.camadasAtivas), function(c) {
    return (!c.camadaUsuario) ? _c('div', {
      staticClass: "camada-ativa-wrapper"
    }, [_c('camada-ativa', {
      attrs: {
        "camada": c
      },
      on: {
        "remove": function($event) {
          _vm.removerCamada(c)
        }
      }
    })], 1) : _vm._e()
  }))], 1), _c('empty-result', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === _vm.ATIVAS && !(_vm.camadasAtivas && _vm.camadasAtivas.length)),
      expression: "tela === ATIVAS && !(camadasAtivas && camadasAtivas.length)"
    }],
    staticClass: "full-height",
    attrs: {
      "message": _vm.filtro ? 'Nenhuma camada encontrada.' : 'Nenhuma camada ativa.'
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-box",
    class: {
      hidden: !_vm.expanded
    },
    attrs: {
      "id": "toolbox"
    }
  }, [_c('div', {
    staticClass: "toolbox-buttons-bar"
  }, _vm._l((_vm.buttons), function(buttonGroup) {
    return _c('div', {
      staticClass: "float-box-btn-group"
    }, _vm._l((buttonGroup), function(button) {
      return _c('div', {
        staticClass: "float-box-btn",
        attrs: {
          "title": button.name
        },
        on: {
          "click": function($event) {
            _vm.callAction(button)
          }
        }
      }, [_c('i', {
        class: button.iconClass
      })])
    }))
  })), _c('div', {
    staticClass: "toolbox-view float-box-view"
  }, [_c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentTitleIconClass),
      expression: "contentTitleIconClass"
    }],
    class: _vm.contentTitleIconClass
  }), _vm._v(_vm._s(_vm.contentTitle))]), _c('i', {
    staticClass: "action-icon mdi mdi-window-close float-box-collapse-icon",
    on: {
      "click": function($event) {
        _vm.collapse()
      }
    }
  })]), _vm._l((_vm.viewComponents), function(comp) {
    return _c(comp, {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (comp.name === _vm.currentComponent),
        expression: "comp.name === currentComponent"
      }],
      key: comp.name,
      ref: comp.name,
      refInFor: true,
      tag: "component"
    })
  })], 2)])
},staticRenderFns: []}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("div")
},staticRenderFns: []}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.parentErrors.has(_vm.name, _vm.scope)),
      expression: "parentErrors.has(name, scope)"
    }],
    staticClass: "invalid-field"
  }, [_vm._v(_vm._s(_vm.msg || _vm.parentErrors.first(_vm.name, _vm.scope)))])
},staticRenderFns: []}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card camada-ativa",
    attrs: {
      "id": 'camada-ativa' + _vm.camada.id
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "col-camada-legenda collapsed",
    class: {
      'cursor-pointer': _vm.camada.estilosPersonalizados && _vm.camada.estilosPersonalizados.length
    },
    attrs: {
      "data-toggle": "collapse",
      "href": '#legendas' + _vm.camada.id,
      "aria-expanded": "false",
      "aria-controls": 'legendas' + _vm.camada.id
    }
  }, [(_vm.camada.estilosPersonalizados && _vm.camada.estilosPersonalizados.length) ? _c('div', {
    staticClass: "camada-expand-icon"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right action-icon pull-left"
  }), _c('i', {
    staticClass: "fa fa-chevron-down action-icon pull-left"
  })]) : _vm._e(), (!_vm.camada.estilosPersonalizados || !_vm.camada.estilosPersonalizados.length) ? _c('div', {
    staticClass: "camada-expand-icon collapsed"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right action-icon pull-left disabled"
  })]) : _vm._e(), _c('icone-legenda', {
    attrs: {
      "estilo": _vm.camada.estiloPadrao,
      "camada": _vm.camada,
      "estilosPersonalizados": _vm.camada.estilosPersonalizados
    }
  })], 1), _c('div', {
    staticClass: "col-camada-nome card-text text-truncate",
    attrs: {
      "title": _vm.camada.nome
    }
  }, [_vm._v(_vm._s(_vm.camada.nome))]), _c('div', {
    staticClass: "col-camada-remove float-right"
  }, [_c('i', {
    staticClass: "mdi mdi-close action-icon float-right",
    on: {
      "click": function($event) {
        _vm.removerCamada(_vm.camada)
      }
    }
  })])]), (_vm.camada.estilosPersonalizados && _vm.camada.estilosPersonalizados.length) ? _c('ul', {
    staticClass: "list-group list-group-flush camada-estilos-personalizados collapse",
    attrs: {
      "id": 'legendas' + _vm.camada.id
    }
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('icone-legenda', {
    attrs: {
      "estilo": _vm.camada.estiloPadrao,
      "camada": _vm.camada
    }
  })], 1), _c('div', {
    staticClass: "col-md-9 camada-descricao-legenda pl-0"
  }, [_vm._v("Padrão")])])]), _vm._l((_vm.camada.estilosPersonalizados), function(estilo) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('icone-legenda', {
      attrs: {
        "estilo": estilo,
        "camada": _vm.camada
      }
    })], 1), _c('div', {
      staticClass: "col-md-9 camada-descricao-legenda pl-0"
    }, _vm._l((estilo.regras), function(regra, index) {
      return _c('span', [_vm._v(" " + _vm._s(index > 0 ? ' e ' + regra.descricao : regra.descricao))])
    }))])])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-camada-drag-icon"
  }, [_c('i', {
    staticClass: "mdi mdi-drag-vertical action-icon"
  })])
}]}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-5 pr-0"
  }, [_c('nav', [_c('ul', {
    staticClass: "pagination pagination-sm"
  }, [(_vm.showPrevious()) ? _c('li', {
    staticClass: "page-item",
    class: {
      'disabled': _vm.currentPage <= 1
    }
  }, [(_vm.currentPage <= 1) ? _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.previousText))])]) : _vm._e(), (_vm.currentPage > 1) ? _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.currentPage - 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.previousText))])]) : _vm._e()]) : _vm._e(), _vm._l((_vm.pages), function(page) {
    return _c('li', {
      staticClass: "page-item",
      class: {
        'active': page === _vm.currentPage
      }
    }, [_c('a', {
      staticClass: "page-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  }), (_vm.showNext()) ? _c('li', {
    staticClass: "page-item",
    class: {
      'disabled': _vm.currentPage === _vm.lastPage || _vm.lastPage === 0
    }
  }, [(_vm.currentPage === _vm.lastPage || _vm.lastPage === 0) ? _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.nextText))])]) : _vm._e(), (_vm.currentPage < _vm.lastPage) ? _c('a', {
    staticClass: "page-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(_vm.currentPage + 1)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.config.nextText))])]) : _vm._e()]) : _vm._e()], 2)])]), _c('div', {
    staticClass: "col-7 pl-0"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Exibindo " + _vm._s(_vm.initialInterval) + "-" + _vm._s(_vm.finalInterval) + " de " + _vm._s(_vm.total))])])])
},staticRenderFns: []}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.currentComponent),
      expression: "!currentComponent"
    }],
    staticClass: "searchbox-map-buttons"
  }, _vm._l((_vm.buttons), function(buttonGroup) {
    return _c('div', {
      staticClass: "float-box-btn-group"
    }, _vm._l((buttonGroup), function(button) {
      return _c('div', {
        staticClass: "float-box-btn",
        attrs: {
          "title": button.name
        },
        on: {
          "click": function($event) {
            _vm.callAction(button)
          }
        }
      }, [_c('i', {
        class: button.iconClass
      })])
    }))
  })), _c('div', {
    staticClass: "float-box",
    class: {
      hidden: !_vm.expanded
    },
    attrs: {
      "id": "searchbox"
    }
  }, [_c('div', {
    staticClass: "searchbox-buttons-bar"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentComponent),
      expression: "currentComponent"
    }],
    staticClass: "searchbox-btn",
    on: {
      "click": function($event) {
        _vm.toogle()
      }
    }
  }, [_c('i', {
    staticClass: "mdi",
    class: {
      'mdi-menu-left': this.expanded, 'mdi-menu-right': !this.expanded
    }
  })])]), _c('div', {
    staticClass: "searchbox-view float-box-view",
    class: {
      'level-1': _vm.registroVisivel
    }
  }, [_c('i', {
    staticClass: "action-icon mdi mdi-window-close float-box-collapse-icon",
    on: {
      "click": function($event) {
        _vm.closeComponent()
      }
    }
  }), _vm._l((_vm.viewComponents), function(comp) {
    return (comp.name === _vm.currentComponent) ? _c(comp, {
      key: comp.name,
      ref: comp.name,
      refInFor: true,
      tag: "component"
    }) : _vm._e()
  })], 2)])])
},staticRenderFns: []}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 empty-result"
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "text-center message"
  }, [_vm._v(_vm._s(_vm.message))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-inbox"
  })])
}]}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Nome:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nome),
      expression: "nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "name": "nome"
    },
    domProps: {
      "value": (_vm.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nome = $event.target.value
      }
    }
  }), _c('input-errors', {
    attrs: {
      "name": "nome"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Cor:")]), _c('color-palette', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "cor"
    },
    on: {
      "input": _vm.onCorChange
    },
    model: {
      value: (_vm.cor),
      callback: function($$v) {
        _vm.cor = $$v
      },
      expression: "cor"
    }
  }), _c('input-errors', {
    attrs: {
      "name": "cor"
    }
  })], 1), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Arquivo shape:")]), _c('shape-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "shapeInput",
    attrs: {
      "name": "shape",
      "max-file-size": 10
    },
    on: {
      "input": _vm.onShapeChange
    },
    model: {
      value: (_vm.geoJsonShape),
      callback: function($$v) {
        _vm.geoJsonShape = $$v
      },
      expression: "geoJsonShape"
    }
  }), _c('input-errors', {
    attrs: {
      "name": "shape"
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 mt-2"
  }, [_c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  }), _vm._v(" Cancelar")]), _c('button', {
    staticClass: "btn btn-primary btn-sm float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.adicionarCamadaShape()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-check"
  }), _vm._v(" Adicionar")])])])])
},staticRenderFns: []}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legenda-icon"
  }, [_c('div', {
    staticClass: "legenda-icon-mapa"
  }, [(!_vm.possuiMapa) ? _c('div', {
    staticClass: "legenda-icon-polygon"
  }) : _vm._e(), (!_vm.possuiMapa) ? _c('div', {
    staticClass: "legenda-icon-disabled"
  }) : _vm._e(), (_vm.possuiMapa && !_vm.isMultiEstilos) ? [(_vm.tipoGeometria.codigo === 'POLYGON') ? _c('div', {
    staticClass: "legenda-icon-polygon",
    style: (_vm.styles)
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POINT') ? _c('div', {
    staticClass: "legenda-icon-point",
    style: (_vm.styles)
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'LINESTRING') ? _c('div', {
    staticClass: "legenda-icon-linestring",
    style: (_vm.styles)
  }) : _vm._e()] : _vm._e(), (_vm.possuiMapa && _vm.isMultiEstilos) ? _c('div', {
    staticClass: "legenda-icon-multi"
  }, [(_vm.tipoGeometria.codigo === 'POLYGON') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-polygon"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POLYGON') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-polygon"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POLYGON') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-polygon"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POINT') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-point"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POINT') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-point"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'POINT') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-point"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'LINESTRING') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-linestring"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'LINESTRING') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-linestring"
  }) : _vm._e(), (_vm.tipoGeometria.codigo === 'LINESTRING') ? _c('div', {
    staticClass: "legenda-icon-multi-item legenda-icon-linestring"
  }) : _vm._e()]) : _vm._e()], 2), _c('div', {
    staticClass: "legenda-icon-marcador"
  }, [(!_vm.possuiMarcador) ? _c('div', {
    staticClass: "beautify-marker marker"
  }) : _vm._e(), (!_vm.possuiMarcador) ? _c('div', {
    staticClass: "legenda-icon-disabled"
  }) : _vm._e(), (_vm.possuiMarcador && !_vm.isMultiEstilos) ? _c('div', {
    staticClass: "beautify-marker marker",
    style: ({
      'background-color': _vm.estilo.marcador.cor
    })
  }) : _vm._e(), (_vm.possuiMarcador && _vm.isMultiEstilos) ? _c('div', {
    staticClass: "legenda-icon-multi"
  }, [_c('div', {
    staticClass: "legenda-icon-multi-item beautify-marker marker"
  }), _c('div', {
    staticClass: "legenda-icon-multi-item beautify-marker marker"
  }), _c('div', {
    staticClass: "legenda-icon-multi-item beautify-marker marker"
  })]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.grupos && _vm.grupos.length) ? _c('ul', {
    staticClass: "list-group listagem-registros"
  }, _vm._l((_vm.grupos), function(g) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('span', {
      staticClass: "listagem-registros-titulo",
      attrs: {
        "title": g.camada.nome
      }
    }, [_vm._v(_vm._s(g.camada.nome))]), _c('small', {
      staticClass: "listagem-registros-subtitulo"
    }, [_vm._v(_vm._s(g.quantidadeRegistros + (g.quantidadeRegistros > 1 ? ' registros' : ' registro')))]), _c('i', {
      staticClass: "action-icon fa fa-chevron-right pull-right",
      on: {
        "click": function($event) {
          _vm.exibirGrupo(g)
        }
      }
    })])
  })) : _vm._e(), (_vm.grupos && _vm.grupos.length === 0) ? _c('empty-result', {
    staticClass: "full-height",
    attrs: {
      "message": "Nenhum resultado encontrado."
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "alert alert-dismissible",
    class: {
      'alert-success': _vm.type === 'success', 'alert-danger': _vm.type === 'error', 'alert-warning': _vm.type === 'warning'
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTitle),
      expression: "showTitle"
    }]
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', [_vm._v(_vm._s(_vm.msg))]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closeFunction),
      expression: "closeFunction"
    }],
    staticClass: "close mdi mdi-close action-icon",
    on: {
      "click": function($event) {
        _vm.closeFunction()
      }
    }
  })]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.registros && _vm.registros.length) ? _c('ul', {
    staticClass: "list-group listagem-registros",
    on: {
      "mouseleave": function($event) {
        _vm.onResultadosMouseLeave()
      }
    }
  }, _vm._l((_vm.registros), function(r) {
    return _c('li', {
      staticClass: "list-group-item",
      on: {
        "mouseenter": function($event) {
          _vm.onRegistroMouseEnter(r)
        }
      }
    }, [_c('span', {
      staticClass: "listagem-registros-titulo",
      attrs: {
        "title": r.titulo
      }
    }, [_vm._v(_vm._s(r.titulo || r.nomeCamada))]), _c('small', {
      staticClass: "listagem-registros-subtitulo"
    }, [_vm._v(_vm._s(r.nomeCamada))]), _c('i', {
      staticClass: "action-icon fa fa-chevron-right pull-right",
      on: {
        "click": function($event) {
          _vm.exibirRegistro(r)
        }
      }
    })])
  })) : _vm._e(), (_vm.registros && _vm.registros.length === 0) ? _c('empty-result', {
    staticClass: "full-height",
    attrs: {
      "message": "Nenhum resultado encontrado."
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'level-1': _vm.grupo && !_vm.registro, 'level-2': _vm.registro
    },
    attrs: {
      "id": "inspecao"
    }
  }, [_c('div', {
    staticClass: "float-box-view-level-0"
  }, [_vm._m(0, false, false), _c('div', {
    staticClass: "col-md-12 float-box-title-extras"
  }, [_c('hr'), _c('ul', {
    staticClass: "nav justify-content-center nav-icons row"
  }, [_c('li', {
    staticClass: "nav-item col-4"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'PONTO'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('PONTO')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-crosshairs-gps"
  }), _c('small', [_vm._v("Ponto")])])]), _c('li', {
    staticClass: "nav-item col-4"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'POLIGONO'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('POLIGONO')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-vector-square"
  }), _c('small', [_vm._v("Área")])])]), _c('li', {
    staticClass: "nav-item col-4"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.tela === 'SHAPE'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.abrirTela('SHAPE')
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-upload"
  }), _c('small', [_vm._v("Shape")])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'PONTO'),
      expression: "tela === 'PONTO'"
    }]
  }, [_c('inspecao-geometria', {
    ref: "PONTO",
    staticClass: "ferramenta-inspecao",
    attrs: {
      "tipoGeometria": _vm.TipoGeometria.PONTO,
      "maxAreaHA": _vm.maxAreaHA
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'POLIGONO'),
      expression: "tela === 'POLIGONO'"
    }]
  }, [_c('inspecao-geometria', {
    ref: "POLIGONO",
    staticClass: "ferramenta-inspecao",
    attrs: {
      "tipoGeometria": _vm.TipoGeometria.POLIGONO,
      "maxAreaHA": _vm.maxAreaHA
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tela === 'SHAPE'),
      expression: "tela === 'SHAPE'"
    }]
  }, [_c('inspecao-shape', {
    ref: "SHAPE",
    staticClass: "ferramenta-inspecao",
    attrs: {
      "maxAreaHA": _vm.maxAreaHA
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.inspecionar
    }
  }, [_c('i', {
    staticClass: "mdi mdi-magnify"
  }), _vm._v(" Inspecionar")]), _c('button', {
    staticClass: "btn btn-outline-secondary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limpar
    }
  }, [_c('i', {
    staticClass: "mdi mdi-eraser"
  }), _vm._v(" Limpar")])])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    staticClass: "float-box-default-padding"
  }, [_c('alert', {
    attrs: {
      "msg": _vm.mensagemErro || '',
      "visible": _vm.showAlert,
      "type": "error"
    }
  })], 1), _c('div', {
    staticClass: "float-box-content"
  }, [(_vm.pesquisaEfetuada) ? _c('listagem-grupos-registros', {
    ref: "listagemGruposRegistros",
    attrs: {
      "grupos": _vm.gruposInformacao
    },
    on: {
      "exibirGrupo": _vm.exibirGrupo
    }
  }) : _vm._e(), (!_vm.pesquisaEfetuada && (!_vm.camadasAtivas || !_vm.camadasAtivas.length)) ? _c('empty-result', {
    staticClass: "full-height",
    attrs: {
      "message": "Nenhuma camada ativa"
    }
  }) : _vm._e()], 1)]), _c('div', {
    staticClass: "float-box-view-level-1"
  }, [(_vm.grupo) ? _c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left action-icon",
    on: {
      "click": function($event) {
        _vm.ocultarGrupo()
      }
    }
  }), _c('span', {
    attrs: {
      "title": _vm.grupo.camada.nome
    }
  }, [_vm._v(_vm._s(_vm.grupo.camada.nome))])])]) : _vm._e(), _c('div', {
    staticClass: "col-12 float-box-content-menu float-box-content-menu-border d-flex flex-row-reverse"
  }, [_c('div', {
    staticClass: "action-link",
    on: {
      "click": function($event) {
        _vm.exportarCSV()
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-download"
  }), _vm._v(" Exportar CSV")])]), _c('div', {
    staticClass: "float-box-content"
  }, [(_vm.paginacaoRegistros && _vm.paginacaoRegistros.itens) ? _c('listagem-registros', {
    ref: "listagemRegistros",
    staticClass: "no-first-border",
    attrs: {
      "registros": _vm.paginacaoRegistros.itens,
      "showMarkers": true
    },
    on: {
      "exibirRegistro": _vm.exibirRegistro
    }
  }) : _vm._e()], 1), (_vm.paginacaoRegistros && _vm.paginacaoRegistros.itens && _vm.paginacaoRegistros.itens.length > 0) ? _c('div', {
    staticClass: "float-box-footer"
  }, [_c('paginacao', {
    ref: "paginacaoRegistros",
    attrs: {
      "total": _vm.paginacaoRegistros.totalItens,
      "page-size": _vm.paginacaoRegistros.itensPorPagina,
      "onChange": _vm.alterarPaginaRegistros,
      "options": _vm.paginationOptions
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "float-box-view-level-2"
  }, [(_vm.registro) ? _c('visualizacao-registro-camada', {
    attrs: {
      "registro": _vm.registro,
      "showReturnButton": true
    },
    on: {
      "close": function($event) {
        _vm.ocultarRegistro()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_c('i', {
    staticClass: "mdi mdi-information-outline"
  }), _vm._v("Inspeção")])])
}]}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-palette"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "form-control dropdown-toggle",
    attrs: {
      "href": "#",
      "role": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.value),
      expression: "!value"
    }]
  }, [_vm._v("Selecionar")]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "color-palette-preview",
    style: ({
      'background-color': _vm.value
    })
  })]), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenuLink"
    }
  }, [_c('table', {
    staticClass: "color-palette-table"
  }, _vm._l((_vm.colors), function(palette) {
    return _c('tr', _vm._l((palette), function(color) {
      return _c('td', {
        on: {
          "click": function($event) {
            _vm.setColor(color)
          }
        }
      }, [_c('div', {
        staticClass: "color-select",
        style: ({
          'background-color': color
        })
      })])
    }))
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.coordinate) ? _c('div', {
    attrs: {
      "id": "componentCoordinates"
    }
  }, [_c('div', {
    class: {
      active: _vm.expanded
    },
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_c('span', [_vm._v("Lat: " + _vm._s(_vm.coordinate.lat.toFixed(4)))]), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v("Lng: " + _vm._s(_vm.coordinate.lng.toFixed(4)))]), _c('i', {
    staticClass: "ml-2 fa fa-angle-up"
  })]), _c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    attrs: {
      "id": "container"
    }
  }, [_c('form', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Coordenadas geográficas")]), _c('div', {
    staticClass: "m-3 body"
  }, [_c('select', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "disabled": true
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }, [_vm._v("Sirgas 2000 geográfico")])]), _c('div', {
    staticClass: "form-row mt-2"
  }, [_c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Latitude")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.latitude),
      expression: "latitude"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('latitude|max_value:85|min_value:-85'),
      expression: "'latitude|max_value:85|min_value:-85'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "placeholder": "± 13.2827",
      "name": "latitude"
    },
    domProps: {
      "value": (_vm.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.latitude = $event.target.value
      }
    }
  }), _c('input-errors', {
    attrs: {
      "name": "latitude"
    }
  })], 1), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('label', [_vm._v("Longitude")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.longitude),
      expression: "longitude"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('longitude'),
      expression: "'longitude'"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "placeholder": "± 26.2589",
      "name": "longitude"
    },
    domProps: {
      "value": (_vm.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.longitude = $event.target.value
      }
    }
  }), _c('input-errors', {
    attrs: {
      "name": "longitude"
    }
  })], 1)])]), _c('div', {
    staticClass: "footer py-2"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-secondary float-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-close"
  }), _vm._v(" Cancelar")]), _c('button', {
    staticClass: "btn btn-sm btn-primary float-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCoordinates()
      }
    }
  }, [_c('i', {
    staticClass: "mdi mdi-check"
  }), _vm._v(" Aplicar")])])])])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'level-1': _vm.registro
    },
    attrs: {
      "id": "informacoesPonto"
    }
  }, [_c('div', {
    staticClass: "float-box-view-level-0"
  }, [_vm._m(0, false, false), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    staticClass: "float-box-default-padding"
  }, [_c('alert', {
    attrs: {
      "msg": _vm.mensagemErro || '',
      "visible": _vm.showAlert,
      "type": "error"
    }
  })], 1), _c('div', {
    staticClass: "float-box-content"
  }, [(_vm.paginacaoRegistros && _vm.paginacaoRegistros.itens) ? _c('listagem-registros', {
    ref: "listagemRegistros",
    attrs: {
      "registros": _vm.paginacaoRegistros.itens,
      "showMarkers": false
    },
    on: {
      "exibirRegistro": _vm.exibirRegistro
    }
  }) : _vm._e(), (!_vm.pesquisaEfetuada && (!_vm.camadasAtivas || !_vm.camadasAtivas.length)) ? _c('empty-result', {
    staticClass: "full-height",
    attrs: {
      "message": "Nenhuma camada ativa"
    }
  }) : _vm._e()], 1), (_vm.paginacaoRegistros && _vm.paginacaoRegistros.itens && _vm.paginacaoRegistros.itens.length > 0) ? _c('div', {
    staticClass: "float-box-footer"
  }, [_c('paginacao', {
    ref: "paginacaoRegistros",
    attrs: {
      "total": _vm.paginacaoRegistros.totalItens,
      "page-size": _vm.paginacaoRegistros.itensPorPagina,
      "onChange": _vm.alterarPaginaRegistros,
      "options": _vm.paginationOptions
    }
  })], 1) : _vm._e()]), _c('div', {
    staticClass: "float-box-view-level-1"
  }, [(_vm.registro) ? _c('visualizacao-registro-camada', {
    attrs: {
      "registro": _vm.registro,
      "showReturnButton": true
    },
    on: {
      "close": function($event) {
        _vm.ocultarRegistro()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 float-box-title"
  }, [_c('h2', {
    staticClass: "pull-left"
  }, [_c('i', {
    staticClass: "mdi mdi-map-marker"
  }), _vm._v("Informações do ponto")])])
}]}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selectedBaseMap) ? _c('div', {
    attrs: {
      "id": "componenteBaseMapSelect"
    }
  }, [_c('div', {
    class: {
      active: _vm.showOptions
    },
    on: {
      "click": function($event) {
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-map-o mr-1"
  }), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v(_vm._s(_vm.selectedBaseMap.name))]), _c('i', {
    staticClass: "fa fa-angle-up"
  })]), _c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOptions),
      expression: "showOptions"
    }],
    attrs: {
      "id": "options"
    }
  }, [_c('div', [_c('a', {
    staticClass: "dropdown-title"
  }, [_vm._v("Mapas de fundo")]), _vm._l((_vm.baseMaps), function(baseMap) {
    return _c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.changeBaseMap(baseMap)
        }
      }
    }, [_vm._v(_vm._s(baseMap.name))])
  })], 2)])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm",
    class: !_vm.drawing ? 'btn-primary' : 'btn-danger',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.draw()
      }
    }
  }, [_c('i', {
    class: !_vm.drawing ? _vm.iconClass : 'mdi mdi-window-close'
  }), _vm._v(" " + _vm._s(_vm.label))])
},staticRenderFns: []}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.currentZoom) ? _c('div', {
    attrs: {
      "id": "componentZoomSelect"
    }
  }, [_c('div', {
    class: {
      active: _vm.showOptions
    },
    on: {
      "click": function($event) {
        _vm.showOptions = !_vm.showOptions
      }
    }
  }, [_c('i', {
    staticClass: "fa i fa fa-search mr-1"
  }), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v("Zoom: " + _vm._s(_vm.mapZoom))]), _c('i', {
    staticClass: "fa fa-angle-up"
  })]), _c('transition', {
    attrs: {
      "name": "el-zoom-in-bottom"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showOptions),
      expression: "showOptions"
    }],
    attrs: {
      "id": "options"
    }
  }, [_c('div', {
    staticClass: "h-100"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Zoom")]), _c('div', {
    staticClass: "d-flex justify-content-center mt-3"
  }, [(_vm.showOptions) ? _c('el-slider', {
    attrs: {
      "vertical": "vertical",
      "min": _vm.minZoom,
      "max": _vm.maxZoom
    },
    on: {
      "change": _vm.updateZoom
    },
    model: {
      value: (_vm.currentZoom),
      callback: function($$v) {
        _vm.currentZoom = $$v
      },
      expression: "currentZoom"
    }
  }) : _vm._e()], 1)])])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[218]);


// WEBPACK FOOTER //
// static/js/app.6bf6a2f546444a72a251.js